import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// Add this import at the top of your file
import { Country, State, City } from 'country-state-city';
import { Multiselect } from 'multiselect-react-dropdown';
import { Container, Row, Col, Image, Form, Button, Modal, Nav, Spinner, ButtonGroup, Tab, Dropdown, Alert } from "react-bootstrap";
import { GiBodyHeight, GiMedicines } from "react-icons/gi";
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaUser, FaEnvelope, FaPhoneAlt, FaCalendarAlt, FaChevronRight, FaChevronLeft, FaTransgender, FaList, FaUserMd, FaPlus, FaEllipsisV, FaWeight, FaHospital, FaBriefcaseMedical, FaSearch, FaGlobe, FaMapMarked, FaCity, FaInfoCircle, FaMicrophone  } from "react-icons/fa";
import PatientRegistrationForm from './PatientRegistrationForm';
import Side from "./Sidebar";
import Top from "./Topbar";
import Loader from "./LoaderModal";
import SuccessAlert from './SuccessAlert';
import ErrorAlert from './ErrorAlert';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import Crypt from '../lib/Crypt';
import C from '../lib/Config';
import { getHospitalFeatures } from '../lib/HospitalConfig';
import moment from 'moment';
import swal from 'sweetalert';
import {Pagination, TableHeader, TableBody, Filter, useDatatableLifecycle, shouldTableUpdate} from 'react-bs-datatable';
import * as XLSX from 'xlsx';
const CustomTable = React.memo(props => {
const {
    data, tableHeaders, onChangeFilter, onPageNavigate, classes, onRowsPerPageChange, onSortChange, tableClass, labels, filterable, filterText, rowsPerPage, currentPage, 
    sortedProp, maxPage, Components
} = useDatatableLifecycle(props);
  
    return (
      <div>
        <Components.Row className="controlRow__root">
          <Components.Col xs="12">
            <Filter
              classes={classes}
              tableHeaders={tableHeaders}
              placeholder='Search by Patient Name'
              onChangeFilter={onChangeFilter}
              filterText={filterText}
              filterable={filterable}
            />
          </Components.Col>
        </Components.Row>
        <Components.Row>
          <Components.Col xs="12">
            <Components.Table className={tableClass}>
              <TableHeader
                classes={classes}
                tableHeaders={tableHeaders}
                sortedProp={sortedProp}
                onSortChange={onSortChange}
                components={{
                  TableHead: Components.TableHead,
                  TableCell: Components.TableCell,
                  TableRow: Components.TableRow
                }}
              />
              <TableBody
                classes={classes}
                tableHeaders={tableHeaders}
                labels={labels}
                data={data}
                components={{
                  TableBody: Components.TableBody,
                  TableCell: Components.TableCell,
                  TableRow: Components.TableRow
                }}
              />
            </Components.Table>
          </Components.Col>
        </Components.Row>
        <Components.Row className="controlRow__root bottom">
          <Components.Col xs={12} md={12} className="text-right">
            <Pagination
              classes={classes}
              data={data}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              onPageNavigate={onPageNavigate}
              labels={labels}
              maxPage={maxPage}
              components={{ Button: Components.Button, ButtonGroup: Components.ButtonGroup }}
            />
          </Components.Col>
        </Components.Row>
      </div>
    );
}, shouldTableUpdate);
const dateFormat = 'DD/MM/yyyy';
const customStyles = `
.input-group .form-control.is-invalid {
    border-color: #ced4da !important;
    background-image: none !important;
    padding-right: 0.75rem !important;
}

.input-group .form-control.is-invalid:focus {
    border-color: #ced4da !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}

.invalid-feedback {
    display: block;
    margin-top: 0.25rem;
}
`;
export default class Case extends Component {
    constructor(props) {
        super(props);
        this.features = getHospitalFeatures();
        this.formBodyRef = React.createRef();   // DOM scope for voice writes
        this.state = {
            showGuidedVoice: false,   // guided voice intake overlay
            newCountryList: [],
            newStateList: [], 
            newCityList: [], 
            selectedNewCountry: {
                countryId: null,
                countryName: ""
            },
            selectedNewState: {
                stateId: null,
                stateName: ""
            },
            selectedNewCity: {
                cityId: null,
                cityCode: ""
            },

            // UI control flags
            isNewStateDropdownDisabled: true,
            isNewCityDropdownDisabled: true,

            // Validation errors specific to new fields
            newLocationErrors: {
                country: "",
                state: "",
                city: ""
            },
            fromPendingProfile: false,
            show: false,
            close: false,
            comorbiditiesArr: [],
            allergiesArr: [],
            anyOngoingTreatmentArr: [{ name: 'Yes', id: 1 }, { name: 'No', id: 2 }, { name: 'Not applicable', id: 3 }, { name: 'Prescribed but not taking', id: 4 }],
            instituteArr: [],
            weightArr: [],
            heightArr: [],
            medicineArr: [],
            genderArr: [],
            countryArr: [],
            isHospitalStaff: false,
            isAssociatedDocSelected: false,
            associatedDocList: [],
            registrationDate: null,
            firstName: '',
            middleName: '',
            lastName: '',
            emailId: '',
            dob: '',
            ageYears: '',
            ageMonths: '',
            ageDays: '',
            isEditingAge: false,
            genderMstDto: { genderId: '' },
            countryDto: { countryId: null, countryCode: '',countryName:'' },
            phoneNumber1: '',
            doctor: { userId: '', firstName: '', lastName: '', username: '', roleName: '' },
            instituteDto: { instituteId: null, instituteName: '' },
            height: null, heightUnit: { unitId: null, unitName: '' },
            weight: null, weightUnit: { unitId: null, unitName: '' },
            patientComorbidities: [],
            patientAllergies: [],
            anyOngoingTreatment: null,
            otherOngoingTreatment: '',
            isOngoingTreatmentSelected: false,
            patientComorbMed: [],
            patientRegErrors: {},
            activeCaseData: [],
            pendingCaseData: [],
            archivedCaseData: [],
            allCaseData: [],
            successAlertshow: false,
            successAlertForArchiveShow: false,
            successAlertclose: false,
            loaderModal: false,
            saveLoader: false,
            associatedDocList: [],
            allergies: '',
            otherComorbidities: '',
            isAllergiesSelected: false,
            isCommorbitiesSelected: false,
            errorAlertshow: false,
            errorAlertclose: false,
            checkDocInstAssociation : false,

            profilePictureName1: '',
            profilePictureData1: '',
            errors: {},

            addressLine1:'',
            addressLine2:'',
            countryNameArr: [],
            countryId: '',
            countryName: '',
            pinCode: '',
            cityArr: [],
            stateArr: [],
            cityCode: '',
            stateName: '',
            category: '',
        //    new field ***************************************
  // Blood Group
     // Updated array formats to match your preferred style
     bloodGroupArr: ['Select Blood Group', 'A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-','Not known'],
     religionArr: ['Select Religion', 'Hinduism', 'Islam', 'Christianity', 'Sikhism', 'Buddhism', 'Jainism', 'Other'],
     educationArr: ['Select Education', 'No Formal Education', 'Primary', 'Secondary', 'Higher Secondary', 'Graduate', 'Post Graduate', 'Doctorate'],
     occupationArr: ['Select Occupation','Unskilled Labour', 'Skilled Labour',
                 'Services', 'Self Employee', 'Businessman', 
                  ' Professional'],
     maritalStatusArr: ['Select Marital Status', 'Single', 'Married', 'Divorced', 'Widowed'],
     idProofTypeArr: ['Select ID Proof Type', 'Aadhaar Card', 'PAN Card', 'Passport', 'Driving License', 'Voter ID'],
     relationArr: ['Select Relation', 
        'Father',
        'Mother', 
        'Spouse', 
        'Son', 
        'Daughter', 
        'Brother', 
        'Sister', 
        'Guardian', 
        'Friend', 
        'Other',
        'Daughter',
        'GrandFather',
        'GrandMother',
        'GrandSon',
        'GrandDaughter',
        'Uncle',
        'Aunt',
        'Nephew',
        'Niece',
        'Cousin'
        
],
     patientTypeArr: ['Select Patient Type', 'Inpatient', 'Outpatient', 'Emergency'],
     referralSourceArr: ['Select Referral Source', 'Self', 'Google', 'Social Media', 'word of Mouth', 'Physician/Doctor','Hospital'],
     selectedReferralSource: '',
  
  // Additional Information
   // Reset the new fields 
   bloodGroup: '',
   religion: '',
   education: '',
   occupation: '',
   maritalStatus: '',
   idProofType: '',
   idProofNumber: '',
   telephoneNumber: '',
   
   // Emergency Contact
   emergencyContactPerson: '',
   emergencyContactRelation: '',
   emergencyMobileType: '',
   emergencyMobileNumber: '',
   emergencyLandlineType: '',
   emergencyLandlineNumber: '',
   
   // Current Address
  
  currentCountryList: [],
  currentStateList: [],
  currentCityList: [],
  selectedCurrentCountry: {
      countryId: null,
      countryName: ""
  },
  selectedCurrentState: {
      stateId: null,
      stateName: ""
  },
  selectedCurrentCity: {
      cityId: null,
      cityCode: ""
  },
  isCurrentStateDropdownDisabled: true,
  isCurrentCityDropdownDisabled: true,
  sameAsPermanent: false,
   
   // Hospital Associated Details
   primaryConsultant: '',
   patientType: '',
   referralSource: '',
   referringPhysician: '',
   referringPhysicianNumber: '',
   referralDetails: '',    

 // Search terms for permanent address
 countrySearchTerm: '',
 stateSearchTerm: '',
 citySearchTerm: '',
 
 // Search terms for current address
 currentCountrySearchTerm: '',
 currentStateSearchTerm: '',
 currentCitySearchTerm: '',
 
 // Filtered lists for permanent address
 filteredCountryList: [],
 filteredStateList: [],
 filteredCityList: [],
 
 // Filtered lists for current address
 filteredCurrentCountryList: [],
 filteredCurrentStateList: [],
 filteredCurrentCityList: [],

        company: '',
        tarrif: '',
        payType: '',
        status: '',
        isRestrictedFieldsVisible: false,
        categoryOptions: ['Select Category', 'Cash', 'Credit'],
        companyOptions: ['Select Company',
        'Cash Patient',
        'Insurance',
        'MJPJAY',
        'AB_ARKA',
        'AASA',
        'MDDSS',
        'YESIC',
        'ECHS',
        'MPKAY',
        'Trial (CRC)',
        'KCC Employee',
        'Insurance GIPSA PPN',
        'Private OPD',
        'Konkan Railway',
        'Airport',
        'KCC Package'],
        tarrifOptions: ['Select Tariff',
        'Cash Patient',
        'Insurance',
        'MJPJAY',
        'AB_ARKA',
        'AASA',
        'MDDSS',
        'YESIC',
        'ECHS',
        'MPKAY',
        'Trial (CRC)',
        'KCC Employee',
        'Insurance GIPSA PPN',
        'Private OPD',
        'Konkan Railway',
        'Airport',
        'KCC Package'],
        payTypeOptions: ['Select Pay Type', 'Cash', 'Credit'],
        statusOptions: ['Select Status', 'Status1', 'Status2', 'Status3'],

        // Bulk upload state
        showBulkUpload: false,
        bulkUploadFile: null,
        bulkUploadLoading: false,
        bulkUploadResult: null,
        bulkUploadError: null,
        bulkValidationErrors: null,
        };
        
        this.handleChange = this.handleChange.bind(this);
        this.getActiveCases = this.getActiveCases.bind(this);
        this.getPendingCases = this.getPendingCases.bind(this);
        this.getArchivedCases = this.getArchivedCases.bind(this);
        this.getAllCases = this.getAllCases.bind(this);
        this.moveToArchive = this.moveToArchive.bind(this);
        this.handleNewCountryChange = this.handleNewCountryChange.bind(this);
        this.handleNewStateChange = this.handleNewStateChange.bind(this);
        this.handleNewCityChange = this.handleNewCityChange.bind(this);
        this.fetchNewCountries = this.fetchNewCountries.bind(this);
        this.fetchNewStates = this.fetchNewStates.bind(this);
        this.fetchNewCities = this.fetchNewCities.bind(this);
        this.fetchCurrentStates = this.fetchCurrentStates.bind(this);
        this.fetchCurrentCities = this.fetchCurrentCities.bind(this);
        this.profilePicHandler = this.profilePicHandler.bind(this);
        this.fileReaderHandler = this.fileReaderHandler.bind(this);
        this.handleCountrySearch = this.handleCountrySearch.bind(this);
        this.handleStateSearch = this.handleStateSearch.bind(this);
        this.handleCitySearch = this.handleCitySearch.bind(this);
        this.handleCurrentCountrySearch = this.handleCurrentCountrySearch.bind(this);
        this.handleCurrentStateSearch = this.handleCurrentStateSearch.bind(this);
        this.handleCurrentCitySearch = this.handleCurrentCitySearch.bind(this);
        this.handleSameAddressChange = this.handleSameAddressChange.bind(this);
    
        this.getCities();
        this.getStates();
    }
 // Fix for the permanent address city display issue
handleNewStateChange = (e) => {
    const stateId = e.target.value;
    
    if (stateId === "") {
        this.setState({
            selectedNewState: { stateId: null, stateName: "" },
            selectedNewCity: { cityId: null, cityCode: "" },
            citySearchTerm: "",
            isNewCityDropdownDisabled: true,
            newCityList: [],
            filteredCityList: []
        });
    } else {
        const selectedState = this.state.newStateList.find(state => state.id === stateId);
        
        // Get cities for the selected country and state
        const stateCities = City.getCitiesOfState(
            this.state.selectedNewCountry.countryId, 
            stateId
        ).map(city => ({
            id: city.name, // Using name as ID since cities don't have ISO codes
            name: city.name
        }));
        
        this.setState({
            selectedNewState: { 
                stateId: selectedState.id, 
                stateName: selectedState.name 
            },
            newCityList: stateCities,
            filteredCityList: stateCities,
            isNewCityDropdownDisabled: stateCities.length === 0
        });
    }
}

// Fix for the current address state and city display issues
handleCurrentCountryChange = (e) => {
    const countryId = e.target.value;
    
    if (countryId === "") {
        this.setState({
            selectedCurrentCountry: { countryId: null, countryName: "" },
            selectedCurrentState: { stateId: null, stateName: "" },
            selectedCurrentCity: { cityId: null, cityCode: "" },
            currentStateSearchTerm: "",
            currentCitySearchTerm: "",
            isCurrentStateDropdownDisabled: true,
            isCurrentCityDropdownDisabled: true,
            currentStateList: [],
            filteredCurrentStateList: [],
            currentCityList: [],
            filteredCurrentCityList: []
        });
    } else {
        const selectedCountry = this.state.currentCountryList.find(country => country.id === countryId);
        
        // Get states for the selected country
        const countryStates = State.getStatesOfCountry(countryId).map(state => ({
            id: state.isoCode,
            name: state.name
        }));
        
        this.setState({
            selectedCurrentCountry: { 
                countryId: selectedCountry.id, 
                countryName: selectedCountry.name 
            },
            currentStateList: countryStates,
            filteredCurrentStateList: countryStates,
            selectedCurrentState: { stateId: null, stateName: "" },
            selectedCurrentCity: { cityId: null, cityCode: "" },
            isCurrentStateDropdownDisabled: countryStates.length === 0,
            isCurrentCityDropdownDisabled: true,
            currentCityList: [],
            filteredCurrentCityList: []
        });
    }
}

// Add a missing handler for Current State change
handleCurrentStateChange = (e) => {
    const stateId = e.target.value;
    
    if (stateId === "") {
        this.setState({
            selectedCurrentState: { stateId: null, stateName: "" },
            selectedCurrentCity: { cityId: null, cityCode: "" },
            currentCitySearchTerm: "",
            isCurrentCityDropdownDisabled: true,
            currentCityList: [],
            filteredCurrentCityList: []
        });
    } else {
        const selectedState = this.state.currentStateList.find(state => state.id === stateId);
        
        // Get cities for the selected country and state
        const stateCities = City.getCitiesOfState(
            this.state.selectedCurrentCountry.countryId, 
            stateId
        ).map(city => ({
            id: city.name, // Using name as ID since cities don't have ISO codes
            name: city.name
        }));
        
        this.setState({
            selectedCurrentState: { 
                stateId: selectedState.id, 
                stateName: selectedState.name 
            },
            currentCityList: stateCities,
            filteredCurrentCityList: stateCities,
            isCurrentCityDropdownDisabled: stateCities.length === 0
        });
    }
}

// Add a missing handler for Current City change
handleCurrentCityChange = (e) => {
    const cityId = e.target.value;
    
    if (cityId === "") {
        this.setState({
            selectedCurrentCity: { cityId: null, cityCode: "" }
        });
    } else {
        const selectedCity = this.state.currentCityList.find(city => city.id === cityId);
        
        this.setState({
            selectedCurrentCity: { 
                cityId: selectedCity.id, 
                cityCode: selectedCity.name
            }
        });
    }
}

// Update the initial state in componentDidMount to include dropdown toggle states for current address
componentDidMount() {
    // Keep your existing code
    this.setState({ loaderModal: true })
    setTimeout(() => {
        this.getActiveCases();
        this.setState({ loaderModal: false })
    }, 1500)
    let data = JSON.parse(localStorage.getItem('userRoleDto'));
    let roleIdFromCache = data.roleId;
    if (roleIdFromCache === 3) {
        this.setState({ isHospitalStaff: true })
    }

    // Add these to your initialization
    this.setState({
        isCountryDropdownOpen: false,
        isStateDropdownOpen: false,
        isCityDropdownOpen: false,
        isCurrentCountryDropdownOpen: false,
        isCurrentStateDropdownOpen: false,
        isCurrentCityDropdownOpen: false
    });

    // Fetch all countries
    this.fetchNewCountries();
    this.getLoggedInUserDetails();
}
    getLoggedInUserDetails = () => {
        const userId = localStorage.getItem("userId");
        const instituteId = this.state.instituteDto.instituteId;
    
        if (userId === '90' || instituteId === 30 || userId === '74' || instituteId === 22) {
            this.setState({ isRestrictedFieldsVisible: true });
        } else {
            this.setState({ isRestrictedFieldsVisible: false });
        }
    }
   // Fetch countries method
// Updated country fetch method using country-state-city library
fetchNewCountries() {
    const allCountries = Country.getAllCountries().map(country => ({
        id: country.isoCode, // or your API's expected format
        name: country.name
    }));
    
    this.setState({ 
        newCountryList: allCountries,
        filteredCountryList: allCountries,
        currentCountryList: allCountries,
        filteredCurrentCountryList: allCountries
    });
}

// Replace your state fetch method
fetchNewStates(countryId) {
    if (!countryId) {
        this.setState({
            newStateList: [],
            filteredStateList: [],
            isNewStateDropdownDisabled: true
        });
        return;
    }
    
    const countryStates = State.getStatesOfCountry(countryId).map(state => ({
        id: state.isoCode,
        name: state.name
    }));
    
    this.setState({
        newStateList: countryStates,
        filteredStateList: countryStates,
        isNewStateDropdownDisabled: countryStates.length === 0
    });
}

// Replace your city fetch method
fetchNewCities(countryId, stateId) {
    if (!countryId || !stateId) {
        this.setState({
            newCityList: [],
            filteredCityList: [],
            isNewCityDropdownDisabled: true
        });
        return;
    }
    
    const stateCities = City.getCitiesOfState(countryId, stateId).map(city => ({
        id: city.name, // Use a unique identifier
        name: city.name
    }));
    
    this.setState({
        newCityList: stateCities,
        filteredCityList: stateCities,
        isNewCityDropdownDisabled: stateCities.length === 0
    });
}

// Current address methods (similar to permanent address methods)

// Fetch countries for current address
fetchCurrentCountries = async () => {
    try {
        const response = await fetch(C.getUrl() + "/patientLocation/getAllCountries");
        const res = await response.json();
        
        // Log the entire response for debugging
        console.log("Current Countries Raw Response:", res);

        // Try different ways of extracting countries data
        let countriesData = [];
        
        if (res.message) {
            try {
                // Try to parse if message is a JSON string
                countriesData = typeof res.message === 'string' 
                    ? JSON.parse(res.message) 
                    : res.message;
            } catch (parseError) {
                console.error("Error parsing countries message:", parseError);
            }
        } else if (Array.isArray(res)) {
            countriesData = res;
        }

        // Ensure we have an array
        if (!Array.isArray(countriesData)) {
            console.error("Expected array but got:", typeof countriesData, countriesData);
            countriesData = [];
        }

        // Format the countries to match existing structure
        const formattedCountries = countriesData.map(country => ({
            id: country.countryId || country.id,
            name: country.countryName || country.name,
            code: country.countryCode || country.code
        }));

        console.log("Formatted Current Countries:", formattedCountries);

        // Update state with the formatted data
        this.setState({ 
            currentCountryList: formattedCountries
        });
    } catch (error) {
        console.error("Error fetching current countries:", error);
        swal({ 
            title: "Error!", 
            text: "Failed to fetch countries", 
            icon: "error", 
            buttons: false, 
            timer: 2000 
        });
    }
};
// Corresponding methods for current address (with same implementation)
// Updated fetch states method for current address
fetchCurrentStates = async (countryId) => {
    try {
        if (!countryId) {
            this.setState({
                currentStateList: [],
                filteredCurrentStateList: [],
                isCurrentStateDropdownDisabled: true,
                currentStateSearchTerm: ''
            });
            return [];
        }
        
        this.setState({ isCurrentStateDropdownDisabled: true });
        
        const response = await fetch(`${C.getUrl()}/patientLocation/getStatesByCountry/${countryId}`);
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const res = await response.json();
        
        // Handle different response formats
        let statesData = [];
        
        if (Array.isArray(res)) {
            statesData = res;
        } else if (res.message) {
            if (typeof res.message === 'string') {
                try {
                    statesData = JSON.parse(res.message);
                } catch (parseError) {
                    console.error("Error parsing states message:", parseError);
                    statesData = [];
                }
            } else if (Array.isArray(res.message)) {
                statesData = res.message;
            }
        } else if (res.data && Array.isArray(res.data)) {
            statesData = res.data;
        }

        // Format the states
        const formattedStates = statesData.map(state => ({
            id: state.stateId || state.id,
            name: state.stateName || state.name
        }));

        // Update state with both main and filtered lists
        this.setState({ 
            currentStateList: formattedStates,
            filteredCurrentStateList: formattedStates,
            isCurrentStateDropdownDisabled: false,
            ...(!this.state.sameAsPermanent ? {
                selectedCurrentState: { stateId: null, stateName: "" },
                selectedCurrentCity: { cityId: null, cityCode: "" }
            } : {}),
            isCurrentCityDropdownDisabled: true,
            currentCityList: [],
            filteredCurrentCityList: [],
            // Reset search term when list changes
            currentStateSearchTerm: ''
        });
        
        return formattedStates;
    } catch (error) {
        console.error("Error fetching current states:", error);
        
        swal({ 
            title: "Error!", 
            text: `Failed to fetch states: ${error.message}`, 
            icon: "error", 
            buttons: false, 
            timer: 2000 
        });
        
        this.setState({
            currentStateList: [],
            filteredCurrentStateList: [],
            isCurrentStateDropdownDisabled: true,
            currentStateSearchTerm: ''
        });
        
        return [];
    }
};
// Process cities from state data
// Fetch cities method with comprehensive logging
fetchNewCities = async (stateId) => {
    try {
        // Log the full URL being called
        const fullUrl = `${C.getUrl()}/patientLocation/getCitiesByState/${stateId}`;
        console.log("Fetching cities from URL:", fullUrl);

        const response = await fetch(fullUrl);
        
        // Log the raw response details
        console.log("Cities Response status:", response.status);
        console.log("Cities Response headers:", Object.fromEntries(response.headers.entries()));

        // Check if the response is ok
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Parse the response
        const res = await response.json();
        console.log("Raw cities response JSON:", res);

        // Debugging: log the structure of the response
        console.log("Cities response type:", typeof res);
        console.log("Cities response keys:", Object.keys(res));

        // Try different ways of extracting the cities data
        let citiesData = [];

        // Option 1: Direct array
        if (Array.isArray(res)) {
            citiesData = res;
        }
        // Option 2: message as JSON string
        else if (res.message && typeof res.message === 'string') {
            try {
                citiesData = JSON.parse(res.message);
            } catch (parseError) {
                console.error("Error parsing cities message:", parseError);
            }
        }
        // Option 3: message as object
        else if (res.message && Array.isArray(res.message)) {
            citiesData = res.message;
        }
        // Option 4: nested structure
        else if (res.data && Array.isArray(res.data)) {
            citiesData = res.data;
        }

        // Log the extracted cities data
        console.log("Extracted cities data:", citiesData);

        // Format the cities
        const formattedCities = citiesData.map(city => ({
            id: city.cityId || city.id,
            name: city.cityName || city.cityCode || city.name
        }));

        console.log("Formatted cities:", formattedCities);

        // Update state with the formatted data
        this.setState({ 
            newCityList: formattedCities,
            filteredCityList: formattedCities,
            isNewCityDropdownDisabled: false,
            selectedNewCity: { cityId: null, cityCode: "" }
        });

        // Return the formatted cities for potential further use
        return formattedCities;
    } catch (error) {
        // Comprehensive error logging
        console.error("Complete cities fetch error details:", {
            name: error.name,
            message: error.message,
            stack: error.stack
        });

        // User-friendly error notification
        swal({ 
            title: "Error!", 
            text: `Failed to fetch cities: ${error.message}`, 
            icon: "error", 
            buttons: false, 
            timer: 3000 
        });

        // Set empty lists to prevent undefined errors
        this.setState({
            newCityList: [],
            filteredCityList: [],
            isNewCityDropdownDisabled: true
        });

        return [];
    }
};

// Replace your current address city fetch
fetchCurrentCities(countryId, stateId) {
    if (!countryId || !stateId) {
        this.setState({
            currentCityList: [],
            filteredCurrentCityList: [],
            isCurrentCityDropdownDisabled: true
        });
        return;
    }
    
    const stateCities = City.getCitiesOfState(countryId, stateId).map(city => ({
        id: city.name, // Use a unique identifier
        name: city.name
    }));
    
    this.setState({
        currentCityList: stateCities,
        filteredCurrentCityList: stateCities,
        isCurrentCityDropdownDisabled: stateCities.length === 0
    });
}

// Add these search handlers for current address
handleCurrentCountrySearch(e) {
    const searchTerm = e.target.value;
    const filteredCountries = this.state.currentCountryList.filter(country => 
        country.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    this.setState({
        currentCountrySearchTerm: searchTerm,
        filteredCurrentCountryList: filteredCountries
    });
}

handleCurrentStateSearch(e) {
    const searchTerm = e.target.value;
    const filteredStates = this.state.currentStateList.filter(state => 
        state.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    this.setState({
        currentStateSearchTerm: searchTerm,
        filteredCurrentStateList: filteredStates
    });
}

handleCurrentCitySearch(e) {
    const searchTerm = e.target.value;
    const filteredCities = this.state.currentCityList.filter(city => 
        city.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    this.setState({
        currentCitySearchTerm: searchTerm,
        filteredCurrentCityList: filteredCities
    });
}
// Search methods for dropdowns
// Add these search handlers for permanent address
handleCountrySearch(e) {
    const searchTerm = e.target.value;
    const filteredCountries = this.state.newCountryList.filter(country => 
        country.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    this.setState({
        countrySearchTerm: searchTerm,
        filteredCountryList: filteredCountries
    });
}

handleStateSearch(e) {
    const searchTerm = e.target.value;
    const filteredStates = this.state.newStateList.filter(state => 
        state.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    this.setState({
        stateSearchTerm: searchTerm,
        filteredStateList: filteredStates
    });
}

handleCitySearch = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    this.setState({
        citySearchTerm: event.target.value,
        filteredCityList: this.state.newCityList.filter(city => 
            city.name.toLowerCase().includes(searchTerm)
        )
    });
};

// Update your country change handler
handleNewCountryChange(e) {
    const countryId = e.target.value;
    
    if (countryId === "") {
        this.setState({
            selectedNewCountry: { countryId: null, countryName: "" },
            selectedNewState: { stateId: null, stateName: "" },
            selectedNewCity: { cityId: null, cityCode: "" },
            stateSearchTerm: "",
            citySearchTerm: ""
        });
    } else {
        const selectedCountry = this.state.newCountryList.find(country => country.id === countryId);
        
        this.setState({
            selectedNewCountry: { 
                countryId: selectedCountry.id, 
                countryName: selectedCountry.name 
            }
        });
    }
    
    // Fetch states for the selected country
    this.fetchNewStates(countryId);
    
    // Reset city data
    this.setState({
        selectedNewCity: { cityId: null, cityCode: "" },
        newCityList: [],
        filteredCityList: [],
        isNewCityDropdownDisabled: true
    });
}


// Fix for the permanent address city display issue
handleNewStateChange = (e) => {
    const stateId = e.target.value;
    
    if (stateId === "") {
        this.setState({
            selectedNewState: { stateId: null, stateName: "" },
            selectedNewCity: { cityId: null, cityCode: "" },
            citySearchTerm: "",
            isNewCityDropdownDisabled: true,
            newCityList: [],
            filteredCityList: []
        });
    } else {
        const selectedState = this.state.newStateList.find(state => state.id === stateId);
        
        // Get cities for the selected country and state
        const stateCities = City.getCitiesOfState(
            this.state.selectedNewCountry.countryId, 
            stateId
        ).map(city => ({
            id: city.name, // Using name as ID since cities don't have ISO codes
            name: city.name
        }));
        
        this.setState({
            selectedNewState: { 
                stateId: selectedState.id, 
                stateName: selectedState.name 
            },
            newCityList: stateCities,
            filteredCityList: stateCities,
            isNewCityDropdownDisabled: stateCities.length === 0
        });
    }
}
// Fix for the current address state and city display issues
handleCurrentCountryChange = (e) => {
    const countryId = e.target.value;
    
    if (countryId === "") {
        this.setState({
            selectedCurrentCountry: { countryId: null, countryName: "" },
            selectedCurrentState: { stateId: null, stateName: "" },
            selectedCurrentCity: { cityId: null, cityCode: "" },
            currentStateSearchTerm: "",
            currentCitySearchTerm: "",
            isCurrentStateDropdownDisabled: true,
            isCurrentCityDropdownDisabled: true,
            currentStateList: [],
            filteredCurrentStateList: [],
            currentCityList: [],
            filteredCurrentCityList: []
        });
    } else {
        const selectedCountry = this.state.currentCountryList.find(country => country.id === countryId);
        
        // Get states for the selected country
        const countryStates = State.getStatesOfCountry(countryId).map(state => ({
            id: state.isoCode,
            name: state.name
        }));
        
        this.setState({
            selectedCurrentCountry: { 
                countryId: selectedCountry.id, 
                countryName: selectedCountry.name 
            },
            currentStateList: countryStates,
            filteredCurrentStateList: countryStates,
            selectedCurrentState: { stateId: null, stateName: "" },
            selectedCurrentCity: { cityId: null, cityCode: "" },
            isCurrentStateDropdownDisabled: countryStates.length === 0,
            isCurrentCityDropdownDisabled: true,
            currentCityList: [],
            filteredCurrentCityList: []
        });
    }
}

// Update your state change handler
handleNewStateChange(e) {
    const stateId = e.target.value;
    
    if (stateId === "") {
        this.setState({
            selectedNewState: { stateId: null, stateName: "" },
            selectedNewCity: { cityId: null, cityCode: "" },
            citySearchTerm: ""
        });
    } else {
        const selectedState = this.state.newStateList.find(state => state.id === stateId);
        
        this.setState({
            selectedNewState: { 
                stateId: selectedState.id, 
                stateName: selectedState.name 
            }
        });
    }
    
    // Fetch cities for the selected state
    this.fetchNewCities(this.state.selectedNewCountry.countryId, stateId);
}

// Add a missing handler for Current State change
handleCurrentStateChange = (e) => {
    const stateId = e.target.value;
    
    if (stateId === "") {
        this.setState({
            selectedCurrentState: { stateId: null, stateName: "" },
            selectedCurrentCity: { cityId: null, cityCode: "" },
            currentCitySearchTerm: "",
            isCurrentCityDropdownDisabled: true,
            currentCityList: [],
            filteredCurrentCityList: []
        });
    } else {
        const selectedState = this.state.currentStateList.find(state => state.id === stateId);
        
        // Get cities for the selected country and state
        const stateCities = City.getCitiesOfState(
            this.state.selectedCurrentCountry.countryId, 
            stateId
        ).map(city => ({
            id: city.name, // Using name as ID since cities don't have ISO codes
            name: city.name
        }));
        
        this.setState({
            selectedCurrentState: { 
                stateId: selectedState.id, 
                stateName: selectedState.name 
            },
            currentCityList: stateCities,
            filteredCurrentCityList: stateCities,
            isCurrentCityDropdownDisabled: stateCities.length === 0
        });
    }
}
// Update your city change handler
handleNewCityChange(e) {
    const cityId = e.target.value;
    
    if (cityId === "") {
        this.setState({
            selectedNewCity: { cityId: null, cityCode: "" }
        });
    } else {
        const selectedCity = this.state.newCityList.find(city => city.id === cityId);
        
        this.setState({
            selectedNewCity: { 
                cityId: selectedCity.id, 
                cityCode: selectedCity.name  // Adjust based on your data structure
            }
        });
    }
}


// Add a missing handler for Current City change
handleCurrentCityChange = (e) => {
    const cityId = e.target.value;
    
    if (cityId === "") {
        this.setState({
            selectedCurrentCity: { cityId: null, cityCode: "" }
        });
    } else {
        const selectedCity = this.state.currentCityList.find(city => city.id === cityId);
        
        this.setState({
            selectedCurrentCity: { 
                cityId: selectedCity.id, 
                cityCode: selectedCity.name
            }
        });
    }
}
// Add this new validation method
validateNewLocationFields = () => {
    let isValid = true;
    const newErrors = {
        country: "",
        state: "",
        city: ""
    };

    if (!this.state.selectedNewCountry.countryId) {
        newErrors.country = "Please select a country";
        isValid = false;
    }

    if (!this.state.selectedNewState.stateId && !this.state.isNewStateDropdownDisabled) {
        newErrors.state = "Please select a state";
        isValid = false;
    }

    if (!this.state.selectedNewCity.cityId && !this.state.isNewCityDropdownDisabled) {
        newErrors.city = "Please select a city";
        isValid = false;
    }

    this.setState({ newLocationErrors: newErrors });
    return isValid;
};
    moveToArchive = (patientID) => {
        //console.log('patientID : ', patientID);
        var patientRegistrationObj = {
            patientID : patientID,
            updatedByIdUser: { userId : localStorage.getItem("userId") }
        }
        //console.log('--- REGITER PATIENT FORM : ' + JSON.stringify(patientRegistrationObj));
        return fetch(C.getUrl() + '/userCase/archivePatientDetails', {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(patientRegistrationObj),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(res => {
            let obj = res;
            let error = obj.subErrors;
            if (error !== null && error !== "") {
                alert(error);
            } else {
                swal({ title: "Patient detail has been moved to archive", icon: "success", buttons: false, timer: 2000, });
                window.location.reload();
            }
        })
        .catch(err => {
            // console.log("Error : " + err);
            swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }

    getActiveCases() {
        let loggedInuser = localStorage.getItem("userId");
        let data = JSON.parse(localStorage.getItem('userRoleDto'));
        let roleIdFromCache = data.roleId;
        //console.log('--ROLE ID ON PATIENT DIALOG : ' + roleIdFromCache)
        let url = '';
        if (roleIdFromCache === 3) {
            url = C.getUrl() + '/userCase/getPatientRegistrationListForStaff?userId=' + loggedInuser + '&status=A';
        }else {
            url = C.getUrl() + '/userCase/getPatientRegistrationList?doctorId=' + loggedInuser + '&status=A';
        }
        return fetch(url, {
            method: 'GET',
            mode: 'cors',
        })
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            let error = resObj.subErrors;
            if (error !== 'undefined' && error !== null && error !== "") {
                swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
            } else {
                let obj = resObj.message;
                if (obj === 'No record found.') { } else {
                  //console.log(obj);
                    let tempData = JSON.parse(resObj.message);
                    let activeCaseData = [];
                    tempData.forEach(obj => {
                        let data = {
                          id : <Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle w-32 mr-2" />,
                          name : <Link to={{ pathname: '/caseprofile', search: 'p=' + obj.patientID }}> {obj.firstName +' '+ obj.lastName} </Link>,
                          caseId : obj.caseId,
                          gender : obj.genderMstDto.genderName,
                          mobileNo : obj.phoneNumber1,
                          hospital : obj.instituteDto.instituteName,
                          doctorName : (obj.doctor !== undefined) ? obj.doctor.firstName +' '+ obj.doctor.lastName : '',
                          button : <Dropdown id="hideToggleIcon">
                                        <Dropdown.Toggle variant="Info" size="sm" id="archivedropdown">
                                            <FaEllipsisV className="side-menu" />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => this.moveToArchive(obj.patientID)}>Move to archive</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                        }
                        activeCaseData.push(data);
                    });
                    //console.log(activeCaseData);
                    this.setState({ activeCaseData: activeCaseData });
                    //console.log(this.state.activeCaseData);
                }
            }
        })
        .catch(err => {
            //console.log("Error : " + err);
            swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }
    getPendingCases() {
        let loggedInuser = localStorage.getItem("userId");
        let data = JSON.parse(localStorage.getItem('userRoleDto'));
        let roleIdFromCache = data.roleId;
        //console.log('--ROLE ID ON PATIENT DIALOG : ' + roleIdFromCache)
        let url = '';
        if (roleIdFromCache === 3) {
            url = C.getUrl() + '/userCase/getPatientRegistrationListForStaff?userId=' + loggedInuser + '&status=N';
        }else {
            url = C.getUrl() + '/userCase/getPatientRegistrationList?doctorId=' + loggedInuser + '&status=N';
        }
        return fetch(url, {
            method: 'GET',
            mode: 'cors',
        })
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            let error = resObj.subErrors;
            if (error !== 'undefined' && error !== null && error !== "") {
                swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
            } else {
                let obj = resObj.message;
                if (obj === 'No record found.') {} else {
                  this.setState({ pendingCaseData: JSON.parse(resObj.message)})
                  //console.log(obj);
                    let tempData = JSON.parse(resObj.message);
                    let pendingCaseData = [];
                    tempData.forEach(obj => {
                        let data = {
                          id : <Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle w-32 mr-2" />,
                          name : <Link to={{ pathname: '/approvecase', search: 'p=' + obj.patientID }}> {obj.firstName +' '+ obj.lastName} </Link>,
                          caseId : obj.caseId,
                          gender : obj.genderMstDto.genderName,
                          mobileNo : obj.phoneNumber1,
                          hospital : obj.instituteDto.instituteName
                        }
                        pendingCaseData.push(data);
                    });
                    //console.log(pendingCaseData);
                    this.setState({ pendingCaseData: pendingCaseData });
                    //console.log(this.state.pendingCaseData);
                }
            }
        })
        .catch(err => {
            swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }
    getArchivedCases() {
        let loggedInuser = localStorage.getItem("userId");
        let data = JSON.parse(localStorage.getItem('userRoleDto'));
        let roleIdFromCache = data.roleId;
        //console.log('--ROLE ID ON PATIENT DIALOG : ' + roleIdFromCache)
        let url = '';
        if (roleIdFromCache === 3) {
            url = C.getUrl() + '/userCase/getPatientRegistrationListForStaff?userId=' + loggedInuser + '&status=R';
        }else {
            url = C.getUrl() + '/userCase/getPatientRegistrationList?doctorId=' + loggedInuser + '&status=R';
        }
        return fetch(url, {
            method: 'GET',
            mode: 'cors',
        })
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            let error = resObj.subErrors;
                if (error !== 'undefined' && error !== null && error !== "") {
                    alert(error);
                } else {
                let obj = resObj.message;
                if (obj === 'No record found.') { } else {
                    this.setState({ archivedCaseData: JSON.parse(resObj.message)})
                    //console.log(obj);
                    let tempData = JSON.parse(resObj.message);
                    let archivedCaseData = [];
                    tempData.forEach(obj => {
                        let data = {
                            id : <Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle w-32 mr-2" />,
                            name : obj.firstName +' '+ obj.lastName,
                            caseId : obj.caseId,
                            gender : obj.genderMstDto.genderName,
                            mobileNo : obj.phoneNumber1,
                            hospital : obj.instituteDto.instituteName,
                            doctorName : (obj.doctor !== undefined) ? obj.doctor.firstName +' '+ obj.doctor.lastName : ''
                        }
                        archivedCaseData.push(data);
                    });
                    //console.log(archivedCaseData);
                    this.setState({ archivedCaseData: archivedCaseData });
                    //console.log(this.state.archivedCaseData);
                }
            }
        })
        .catch(err => {
            //console.log("Error : " + err);
            swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }
    getAllCases() {
        let loggedInuser = localStorage.getItem("userId");
        let data = JSON.parse(localStorage.getItem('userRoleDto'));
        let roleIdFromCache = data.roleId;
        //console.log('--ROLE ID ON PATIENT DIALOG : ' + roleIdFromCache)
        let url = '';
        if (roleIdFromCache === 3) {
            url = C.getUrl() + '/userCase/getPatientRegistrationListForStaff?userId=' + loggedInuser + '&status';
        }else {
            url = C.getUrl() + '/userCase/getPatientRegistrationList?doctorId=' + loggedInuser + '&status';
        }
        return fetch(url, {
            method: 'GET',
            mode: 'cors',
        })
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            let error = resObj.subErrors;
            if (error !== 'undefined' && error !== null && error !== "") {
                alert(error);
            } else {
                let obj = resObj.message;
            if (obj === 'No record found.') { } else {
                this.setState({ allCaseData: JSON.parse(resObj.message)})
                //console.log(obj);
                  let tempData = JSON.parse(resObj.message);
                  let allCaseData = [];
                  tempData.forEach(obj => {
                      let data = {
                        id : <Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle w-32 mr-2" />,
                        name : obj.firstName +' '+ obj.lastName,
                        caseId : obj.caseId,
                        gender : obj.genderMstDto.genderName,
                        mobileNo : obj.phoneNumber1,
                        hospital : obj.instituteDto.instituteName,
                        doctorName : (obj.doctor !== undefined) ? obj.doctor.firstName +' '+ obj.doctor.lastName : ''
                      }
                      allCaseData.push(data);
                  });
                  //console.log(allCaseData);
                  this.setState({ allCaseData: allCaseData });
                  //console.log(this.state.allCaseData);
              }
            }
        })
        .catch(err => {
            // console.log("Error : " + err);
            swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }

    getRegistrationCasesByStatus(status) {
        let loggedInuser = localStorage.getItem('userId');
        return fetch(C.getUrl() + '/userCase/getPatientRegistrationList?doctorId=' + loggedInuser + '&status=' + status, {
            method: 'GET',
            mode: 'cors',
        })
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            let error = resObj.subErrors;
            if (error !== 'undefined' && error !== null && error !== "") {
                alert(error);
            } else {
                let obj = resObj.message;
                if (obj === 'No record found.') { } else {
                    this.setState({ activeCaseData: [], pendingCaseData: [], archivedCaseData: [], allCaseData: [] });
                    if (status === 'N') {
                        this.setState({ loaderModal: true })
                        setTimeout(() => {
                            this.setState({ pendingCaseData: JSON.parse(resObj.message), loaderModal: false })
                        }, 1000)
                    } else if (status === 'R') {
                        this.setState({ loaderModal: true })
                        setTimeout(() => {
                            this.setState({ archivedCaseData: JSON.parse(resObj.message), loaderModal: false })
                        }, 1000)
                    } else {
                        this.setState({ loaderModal: true })
                        setTimeout(() => {
                            this.setState({ allCaseData: JSON.parse(resObj.message), loaderModal: false })
                        }, 1000)
                    }
                }
            }
        })
        .catch(err => {
            //console.log("Error : " + err);
            swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }

    getAssociatedDocList = async () => {
        let userId = localStorage.getItem('userId');
        return fetch(C.getUrl() + `/user/getUserByUserId/${userId}`)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let msg = resObj.message
                let data = JSON.parse(msg);
                let doc = data.associatedDoctorDTOList;
                var arr = [];
                doc.map((item, i) => {
                    arr.push({
                        key: Crypt.getUniqueKey(i),
                        id: item.userId,
                        name: `${item.firstName} ${item.lastName}`,
                        firstName: item.firstName,
                        lastName: item.lastName
                    });
                });
                this.setState({ associatedDocList: arr });
                //console.table(arr);
            })
            .catch(err => {
                //console.log("Error : " + err);
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }
    getallCountries() {
        return fetch(C.getUrl() + '/countryMaster/getallCountries')
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let msg = resObj.message
                let data = JSON.parse(msg);
                var arr = [];
                var countryNameArr = [];//newly added
                data.map(function (d) {
                    arr.push({ id: d.countryId, name: d.countryCode + ' ' + d.phoneContryCode });
                    countryNameArr.push({ id: d.countryId, name: d.countryName });
                });
                this.setState({ countryArr: arr });
                //console.log("countryArr : " + JSON.stringify(this.state.countryArr));
                this.setState({ countryArr: arr,countryNameArr: countryNameArr });
                console.log("countryArr : " + JSON.stringify(this.state.countryArr));
            })
            .catch(err => {
                //console.log("Error : " + err);
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getAllGender() {
        return fetch(C.getUrl() + '/genderMaster/getAllGenders')
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let msg = resObj.message
                let data = JSON.parse(msg);
                var arr = [];
                data.map(function (d) {
                    arr.push({ id: d.genderId, name: d.genderName });
                });
                this.setState({ genderArr: arr });
                //console.log("genderArr : " + JSON.stringify(this.state.genderArr));
            })
            .catch(err => {
               swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getAllMedicines() {
        return fetch(C.getUrl() + '/medicineMst/getAllMedicines')
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let data = Array.isArray(resObj) ? resObj : (resObj.message ? JSON.parse(resObj.message) : []);
                var arr = [];
                if (Array.isArray(data)) {
                    data.map(function (d) {
                        arr.push({ id: d.medicineId, name: d.medicineName });
                    });
                }
                this.setState({ medicineArr: arr });
                //console.log("medicineArr : " + JSON.stringify(this.state.medicineArr));
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getAllUnits() {
        return fetch(C.getUrl() + '/unitMst/getAllUnits')
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let data = Array.isArray(resObj) ? resObj : (resObj.message ? JSON.parse(resObj.message) : []);
                var ht = [];
                var wt = [];
                if (Array.isArray(data)) {
                    data.map((item, index) => {
                        if (item.unitCategory === 'wt') {
                            wt.push({ id: item.unitId, name: item.unitName });
                            if(item.unitName==='KG' || item.unitName==='kg'){
                                this.setState({ weightUnit: { unitId: item.unitId } });
                            }
                        }
                        if (item.unitCategory === 'len') {
                            ht.push({ id: item.unitId, name: item.unitName });
                            if(item.unitName==='cm' || item.unitName==='CM'){
                                this.setState({ heightUnit: { unitId: item.unitId } });
                            }
                        }
                    })
                }
                this.setState({ weightArr: wt, heightArr: ht });
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getAllAllergies() {
        return fetch(C.getUrl() + '/allergies/getAllAlergies')
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let data = Array.isArray(resObj) ? resObj : (resObj.message ? JSON.parse(resObj.message) : []);
                var arr = [];
                if (Array.isArray(data)) {
                    data.map(function (d) {
                        arr.push({ id: d.allergiesId, name: d.allergiesName });
                    });
                }
                this.setState({ allergiesArr: arr });
                //console.log("allergiesArr : " + JSON.stringify(this.state.allergiesArr));
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getAllComorbidites() {
        return fetch(C.getUrl() + '/comorbidities/getAllcomorbidities')
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let data = Array.isArray(resObj) ? resObj : (resObj.message ? JSON.parse(resObj.message) : []);
                var arr = [];
                if (Array.isArray(data)) {
                    data.map(function (d) {
                        arr.push({ id: d.comorbiditiesId, name: d.comorbiditiesName });
                    });
                }
                this.setState({ comorbiditiesArr: arr });
                //console.log("comorbiditiesArr : " + JSON.stringify(this.state.comorbiditiesArr));
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getAllInstitute() {
        let userId = localStorage.getItem('userId');
        return fetch(C.getUrl() + '/institute/getAllInstituteByUserId/'+userId)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let data = Array.isArray(resObj) ? resObj : (resObj.message ? JSON.parse(resObj.message) : []);
                var arr = [];
                if (Array.isArray(data)) {
                    data.map(function (d) {
                        arr.push({ id: d.instituteId, name: d.instituteName });
                    });
                }
                this.setState({ instituteArr: arr });
                //console.log("instituteArr : " + JSON.stringify(this.state.instituteArr));
            })
            .catch(err => {
                //swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getAllInstituteAssociated(docId) {
        return fetch(C.getUrl() + '/institute/getAllInstituteByUserId/'+docId)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let data = Array.isArray(resObj) ? resObj : (resObj.message ? JSON.parse(resObj.message) : []);
                var arr = [];
                if (Array.isArray(data)) {
                    data.map(function (d) {
                        arr.push({ id: d.instituteId, name: d.instituteName });
                    });
                }
                this.setState({ instituteArr: arr });
                //console.log("instituteArr : " + JSON.stringify(this.state.instituteArr));
            })
            .catch(err => {
                //swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getAssociatedDocList = async () => {
        let userId = localStorage.getItem('userId');
        return fetch(C.getUrl() + `/user/getUserByUserId/${userId}`)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let msg = resObj.message
                let data = JSON.parse(msg);
                let doc = data.associatedDoctorDTOList;
                var arr = [];
                doc.map((item, i) => {
                    arr.push({
                        key: Crypt.getUniqueKey(i),
                        id: item.userId,
                        name: `${item.firstName} ${item.lastName}`,
                        firstName: item.firstName,
                        lastName: item.lastName
                    });
                });
                this.setState({ associatedDocList: arr });
                //console.table(arr);
            })
            .catch(err => {
                //swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getTodayDate() {
        return new Date().toJSON().slice(0, 10).split('-').reverse().join('/');
    }

    handleChange(event) {
        const { associatedDocList } = this.state;
        if (event.target.name === 'registrationDate') {
            this.setState({ registrationDate: event.target.value });
        }
        if (event.target.name === 'firstName') {
            this.setState({ firstName: event.target.value });
        }
        if (event.target.name === 'middleName') {
            this.setState({ middleName: event.target.value });
        }
        if (event.target.name === 'lastName') {
            this.setState({ lastName: event.target.value });
        }
        if (event.target.name === 'email') {
            this.setState({ emailId: event.target.value });
        }
        if (event.target.name === 'addressline1') {
            this.setState({ addressLine1: event.target.value });
        }
        if (event.target.name === 'addressline2') {
            this.setState({ addressLine2: event.target.value });
        }
        if (event.target.name === 'pinCode') {
            this.setState({ pinCode: event.target.value });
        }
        if (event.target.name === 'cityCode') {
            this.setState({ cityCode: event.target.value });
        }
        if (event.target.name === 'pinCode') {
            const regex = /^[0-9\b]+$/; 
            if (event.target.value === '' || (regex.test(event.target.value) && event.target.value.length <= 10)) {
                this.setState({ pinCode: event.target.value });
            }
            return;
        }
        if (event.target.name === 'stateName') {
            this.setState({ stateName: event.target.value });
        }
        if (event.target.name === 'phoneNumber1') {
            this.setState({ phoneNumber1: event.target.value });
        }
        if (event.target.name === 'dob') {
            this.setState({ dob: event.target.value });
        }
        if (event.target.name === 'weight') {
            this.setState({ weight: event.target.value });
        }
        if (event.target.name === 'weightUnit') {
            this.setState({ weightUnit: { unitId: event.target.value } });
        }
        if (event.target.name === 'height') {
            this.setState({ height: event.target.value });
        }
        if (event.target.name === 'heightUnit') {
            this.setState({ heightUnit: { unitId: event.target.value } });
        }
        if (event.target.name === 'gender') {
            console.log(JSON.stringify(event.target.value))
            this.setState({ genderMstDto: { genderId: event.target.value } });
        }
        if (event.target.name === 'institute') {
            this.setState({ instituteDto: { instituteId: event.target.value } });
        }
        if (event.target.name === 'country') {
            this.setState({ countryDto: { countryId: event.target.value } });
        }
        if (event.target.name === 'countryName') {
            this.setState({ countryName: event.target.value });
        }
        if (event.target.name === 'category') {
            this.setState({ category: event.target.value });
        }
        if (event.target.name === 'company') {
            this.setState({ company: event.target.value });
        }
        if (event.target.name === 'tarrif') {
            this.setState({ tarrif: event.target.value });
        }
        if (event.target.name === 'payType') {
            this.setState({ payType: event.target.value });
        }
        if (event.target.name === 'status') {
            this.setState({ status: event.target.value });
        }
         // Add this to handle referralDetails
         if (event.target.name === 'referralDetails') {
            this.setState({ referralDetails: event.target.value });
        }
    
    // Make sure the referringHospital is properly handled
    if (event.target.name === 'referringHospital') {
        this.setState({ referringHospital: event.target.value });
    }

        if (event.target.name === 'anyOngoingTreatment') {
            const selectedOption = this.state.anyOngoingTreatmentArr.find((option) => option.id == event.target.value);
            const isYesSelected = selectedOption && selectedOption.name === 'Yes';
      
            this.setState({
              anyOngoingTreatment: selectedOption ? selectedOption.name : '',
              isOngoingTreatmentSelected: isYesSelected,
              otherOngoingTreatment: isYesSelected ? this.state.otherOngoingTreatment : '' 
            });
          }
      
          if (event.target.name === 'otherOngoingTreatment') {
            this.setState({ otherOngoingTreatment: event.target.value });
          }

        if (event.target.name === 'comorbiditiesMedicine') {
            this.setState({ patientComorbMed: event.target.value });
        }
        if (event.target.name === 'docList') {
            associatedDocList.map((item, i) => {
                if (event.target.value === item.id + '') {
                    this.setSelectedDocData(item)
                }
            });
        }
        if (event.target.name === 'allergies') {
            this.setState({ allergies: event.target.value });
        }
        if (event.target.name === 'otherComorbidities') {
            this.setState({ otherComorbidities: event.target.value });
        }

        // Blood Group
if (event.target.name === 'bloodGroup') {
    this.setState({ bloodGroup: event.target.value });
}

// Religion, Education, Occupation
if (event.target.name === 'religion') {
    this.setState({ religion: event.target.value });
}
if (event.target.name === 'education') {
    this.setState({ education: event.target.value });
}
if (event.target.name === 'occupation') {
    this.setState({ occupation: event.target.value });
}
if (event.target.name === 'maritalStatus') {
    this.setState({ maritalStatus: event.target.value });
}

// ID Proof
if (event.target.name === 'idProofType') {
    this.setState({ idProofType: event.target.value });
}
if (event.target.name === 'idProofNumber') {
    this.setState({ idProofNumber: event.target.value });
}

// Emergency Contact
if (event.target.name === 'emergencyContactPerson') {
    this.setState({ emergencyContactPerson: event.target.value });
}
if (event.target.name === 'emergencyContactRelation') {
    this.setState({ emergencyContactRelation: event.target.value });
}
if (event.target.name === 'emergencyMobileType') {
    this.setState({ emergencyMobileType: event.target.value });
}
if (event.target.name === 'emergencyMobileNumber') {
    this.setState({ emergencyMobileNumber: event.target.value });
}
if (event.target.name === 'emergencyLandlineType') {
    this.setState({ emergencyLandlineType: event.target.value });
}
if (event.target.name === 'emergencyLandlineNumber') {
    this.setState({ emergencyLandlineNumber: event.target.value });
}

// Current Address
if (event.target.name === 'currentAddressLine1') {
    this.setState({ currentAddressLine1: event.target.value });
}
if (event.target.name === 'currentAddressLine2') {
    this.setState({ currentAddressLine2: event.target.value });
}
if (event.target.name === 'currentCountry') {
    this.setState({ currentCountry: event.target.value });
}
if (event.target.name === 'currentState') {
    this.setState({ currentState: event.target.value });
}
if (event.target.name === 'currentCity') {
    this.setState({ currentCity: event.target.value });
}
if (event.target.name === 'currentPinCode') {
    this.setState({ currentPinCode: event.target.value });
}

// Hospital Associated Details
if (event.target.name === 'primaryConsultant') {
    this.setState({ primaryConsultant: event.target.value });
}
if (event.target.name === 'patientType') {
    this.setState({ patientType: event.target.value });
}
if (event.target.name === 'referralSource') {
    this.setState({ referralSource: event.target.value });
}
if (event.target.name === 'telephoneNumber') {
    this.setState({ telephoneNumber: event.target.value });
}
// Referral Details (if missing)
if (event.target.name === 'referringPhysician') {
    this.setState({ referringPhysician: event.target.value });
}
if (event.target.name === 'referringPhysicianNumber') {
    this.setState({ referringPhysicianNumber: event.target.value });

  
}
    }

    nextButtonHandler = () => {
        if (this.validateGeneralInfo()) {
            const nextTab = document.getElementById("nextTab");
            const currentTab = document.getElementById("nextTab1");
            
            if (nextTab && currentTab) {
                nextTab.style.display = "block";
                currentTab.style.display = "none";
                nextTab.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }

    previousButtonHandler = () => {
        const nextTab = document.getElementById("nextTab");
        const currentTab = document.getElementById("nextTab1");
        
        if (nextTab && currentTab) {
            nextTab.style.display = "none";
            currentTab.style.display = "block";
            currentTab.scrollIntoView({ behavior: 'smooth' });
        }
    }

    validateGeneralInfo = () => {
        let formIsValid = true;
        let errors = {};
        if (this.state.doctor === "" || this.state.doctor === null ||
            this.state.doctor.userId === null || this.state.doctor.userId === 0) {
            //console.log("Doctor " + this.state.doctor.userId);
            errors["doctor"] = "Doctor's name not specified";
            formIsValid = false;
        }
        if (this.state.firstName === "" || this.state.firstName == null) {
            errors["firstName"] = "Please enter first name";
            formIsValid = false;
        }
        if (this.state.lastName === "" || this.state.lastName == null) {
            errors["lastName"] = "Please enter last name";
            formIsValid = false;
        }
        // if (this.state.emailId === "" || this.state.emailId == null) {
        //     errors["email"] = "Please enter valid email address";
        //     formIsValid = false;
        // } else if (this.state.emailId !== "undefined") {
        //     let lastAtPos = this.state.emailId.lastIndexOf('@');
        //     let lastDotPos = this.state.emailId.lastIndexOf('.');
        //     if (!(lastAtPos < lastDotPos && lastAtPos > 0 && this.state.emailId.indexOf('@@') === -1
        //         && lastDotPos > 2 && (this.state.emailId.length - lastDotPos) > 2)) {
        //         formIsValid = false;
        //         errors["email"] = "Please enter valid email address";
        //     }
        // }
        if (this.state.addressLine1 === "" || this.state.addressLine1 == null) {
            errors["addressline1"] = "Please enter address line 1";
            formIsValid = false;
        }
        if (this.state.pinCode === '' || this.state.pinCode === null) {
            errors["pinCode"] = "Please enter pin code";
            formIsValid = false;
        } 
        else if (this.state.pinCode.length !== 6) {
            errors["pinCode"] = "Pin code must be 6 digits";
            formIsValid = false;
        }
        if (this.state.dob === "" || this.state.dob === null) {
            errors["dob"] = "Date of birth cannot be empty";
            formIsValid = false;
        }
        if (this.state.genderMstDto === null || this.state.genderMstDto.genderId === '' || this.state.genderMstDto.genderId === null) {
            errors["gender"] = "Please select gender";
            formIsValid = false;
        }
        // if (this.state.height === '' || this.state.height === null) {
        //     errors["height"] = "Please enter height";
        //     formIsValid = false;
        // }
        // else if (this.state.height.toString().length > 3) { 
        //     errors["height"] = "Height must be 3 digits or less";
        //     formIsValid = false;
        // }
        // if (this.state.weight === '' || this.state.weight === null) {
        //     errors["weight"] = "Please enter weight ";
        //     formIsValid = false;
        // }
        if (this.state.phoneNumber1 === "" || this.state.phoneNumber1 === null) {
            errors["phoneNumber1"] = "Contact no cannot be empty";
            formIsValid = false;
        }
        if (this.state.phoneNumber1 !== "" && this.state.phoneNumber1 !== null) {
            let num = this.state.phoneNumber1;
            if (num.length > 10 || num.length < 10) {
                errors["phoneNumber1"] = "Contact no must be 10 digits";
                formIsValid = false;
            }
        }
        if (this.state.instituteDto === null || this.state.instituteDto.instituteId === null || this.state.instituteDto.instituteId === '') {
            errors["institute"] = "Please select institute";
            formIsValid = false;
        }
        
        if (this.state.countryDto === null || this.state.countryDto.countryId === null) {
            errors["country"] = "Please select a country Code";
            formIsValid = false;
        }
        // Add new validations for country, state and city
    if (!this.state.selectedNewCountry.countryId) {
        errors["newCountry"] = "Please select country name";
        formIsValid = false;
    }

    // For state validation, check if country is selected first
    if (!this.state.selectedNewState.stateId) {
        if (!this.state.selectedNewCountry.countryId) {
            errors["newState"] = "Please select country name first";
        } else {
            errors["newState"] = "Please select state name";
        }
        formIsValid = false;
    }

    // For city validation, check if state is selected first
    if (!this.state.selectedNewCity.cityId) {
        if (!this.state.selectedNewState.stateId) {
            errors["newCity"] = "Please select state name first";
        } else {
            errors["newCity"] = "Please select city name";
        }
        formIsValid = false;
    }

     // New validations for patient type
     if (this.state.patientType === "DEFAULT" || this.state.patientType === null || this.state.patientType === "") {
        errors["patientType"] = "Please select patient type";
        formIsValid = false;
    }
    
    // Validation for Primary Consultant
    if (this.state.primaryConsultant === "" || this.state.primaryConsultant === null) {
        errors["primaryConsultant"] = "Please enter primary consultant";
        formIsValid = false;
    }
    
    // Emergency contact person validation
    if (this.state.emergencyContactPerson === "" || this.state.emergencyContactPerson === null) {
        errors["emergencyContactPerson"] = "Please enter emergency contact person";
        formIsValid = false;
    }
    
    // Emergency contact relation validation
    if (this.state.emergencyContactRelation === "" || this.state.emergencyContactRelation === null) {
        errors["emergencyContactRelation"] = "Please select emergency contact relation";
        formIsValid = false;
    }
    
    // Emergency contact number validation
    if (this.state.emergencyMobileNumber === "" || this.state.emergencyMobileNumber === null) {
        errors["emergencyMobileNumber"] = "Emergency contact number cannot be empty";
        formIsValid = false;
    } else if (this.state.emergencyMobileNumber.length !== 10) {
        errors["emergencyMobileNumber"] = "Emergency contact number must be 10 digits";
        formIsValid = false;
    }
    
    // Blood group validation
    if (this.state.bloodGroup === "DEFAULT" || this.state.bloodGroup === null || this.state.bloodGroup === "") {
        errors["bloodGroup"] = "Please select blood group";
        formIsValid = false;
    }

     // Add this to your existing validateGeneralInfo function

// Validation for referring physician phone number
if (this.state.referringPhysicianNumber) {
    // If provided, ensure it's a valid format (numbers only)
    const phoneRegex = /^\d+$/;
    if (!phoneRegex.test(this.state.referringPhysicianNumber)) {
      errors["referringPhysicianNumber"] = "Referring physician number should contain only digits";
      formIsValid = false;
    } else if (this.state.referringPhysicianNumber.length > 10) {
      errors["referringPhysicianNumber"] = "Referring physician number cannot exceed 10 digits";
      formIsValid = false;
    }
  }
  
  // Update the emergency contact and telephone validation to match the pattern
  // Emergency contact number validation
  if (this.state.emergencyMobileNumber === "" || this.state.emergencyMobileNumber === null) {
    errors["emergencyMobileNumber"] = "Emergency contact number cannot be empty";
    formIsValid = false;
  } else if (this.state.emergencyMobileNumber.length !== 10) {
    errors["emergencyMobileNumber"] = "Emergency contact number must be 10 digits";
    formIsValid = false;
  }
  
  // Validation for telephone number
  if (this.state.telephoneNumber) {
    // If provided, ensure it's a valid format (numbers only)
    const phoneRegex = /^\d+$/;
    if (!phoneRegex.test(this.state.telephoneNumber)) {
      errors["telephoneNumber"] = "Telephone number should contain only digits";
      formIsValid = false;
    } else if (this.state.telephoneNumber.length > 10) {
      errors["telephoneNumber"] = "Telephone number cannot exceed 10 digits";
      formIsValid = false;
    }
  }
    
    // Validation for referring physician phone number
    if (this.state.selectedReferralSource === 'Physician/Doctor' || this.state.selectedReferralSource === 'Hospital') {
        if (this.state.referringPhysicianNumber) {
            const phoneRegex = /^\d+$/;
            if (!phoneRegex.test(this.state.referringPhysicianNumber)) {
                errors["referringPhysicianNumber"] = "Physician phone number should contain only digits";
                formIsValid = false;
            }
        }
    }
    // Update the patientRegErrors state with new errors
    this.setState({ 
        patientRegErrors: {
            ...errors,
            newCountry: errors["newCountry"] || "",
            newState: errors["newState"] || "",
            newCity: errors["newCity"] || ""
        } 
    });

        this.setState({ patientRegErrors: errors });
        return formIsValid;
    }
    validateProfessionalInfo = () => {
        let formIsValid = true;
        let errors = {};
        this.setState({ patientRegErrors: errors });
        return formIsValid;
    }
    setComorbidities(value) {
        this.setState({ patientComorbidities: value });
        let tempValue = JSON.stringify(value);
        if (tempValue !== null && tempValue !== '[]') {
            let jsonValue = JSON.parse(tempValue);
            let flag = false;
            jsonValue.map((item) => {
                if (item.name === 'Others- Specify' || item.name === 'Other commorbities, please specify') {
                    flag = true;
                }
            });
            if(flag){
                this.setState({ isCommorbitiesSelected: true });
            }else{
                this.setState({ isCommorbitiesSelected: false });
            }
        }else{
            this.setState({ isCommorbitiesSelected: false });
        }
    }
    setPatientAllergies(value) {
        this.setState({ patientAllergies: value });
        let tempValue = JSON.stringify(value);
        if (tempValue !== null && tempValue !== '[]') {
            let jsonValue = JSON.parse(tempValue);
            let flag = false;
            jsonValue.map((item) => {
                if (item.name === 'Other chemotherapy allergies, please specify' || item.name === 'Other Allergies, please specify') {
                    flag = true;
                }
            });
            if(flag){
                this.setState({ isAllergiesSelected: true });
            }else{
                this.setState({ isAllergiesSelected: false });
            }
        }else{
            this.setState({ isAllergiesSelected: false });
        }
    }
    setComorbiditiesMedicine(value) {
        this.setState({ patientComorbMed: value });
    }

    checkDoctorInstituteAssociation(){
        let userId = localStorage.getItem('userId');
        return fetch(C.getUrl() + `/institute/checkDoctorInstituteAssociation/${userId}`)
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            let msg = resObj.message
            if(resObj.statusCode == '200'){
                this.setState({ checkDocInstAssociation : true});
            }else{
                this.setState({ checkDocInstAssociation : false});
                swal({ title: "Warning!", text: msg, icon: "warning", buttons: "OK", timer: false });
                this.setState({ show: false });
            }
            //console.table(arr);
        })
        .catch(err => {
            swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }

    showPatientDialog() {
        let data = JSON.parse(localStorage.getItem('userRoleDto'));
        let roleIdFromCache = data.roleId;
        if(roleIdFromCache !== 3){
            this.checkDoctorInstituteAssociation();
        }else{
            this.setState({ checkDocInstAssociation : true});
        }
        setTimeout(() => {
            if(this.state.checkDocInstAssociation){
                this.resetRegistrationForm();
                // Clear age-related fields here
                this.setState({
                    ageYears: '',
                    ageMonths: '',
                    ageDays: '',
                    dob: null, // Reset the date of birth
                });
                this.getAllInstitute();
                this.getAllAllergies();
                this.getAllComorbidites();
                this.getAllUnits();
                this.getAllGender();
                this.getAllMedicines();
                this.getPatientDoc();
                this.getallCountries();
                //console.log('--ROLE ID ON PATIENT DIALOG : ' + roleIdFromCache)
                if (roleIdFromCache === 3) {
                    this.getAssociatedDocList();
                    this.setState({ show: true, isHospitalStaff: true, isAssociatedDocSelected: false });
                } else {
                    this.setState({ show: true });
                }
            }
        }, 200)
    }

    getCities() {
        return fetch(C.getUrl() + '/cityMaster/getallCities')
            .then(res => res.json())
            .then(data => {
                const cityArr = JSON.parse(data.message);
                this.setState({ cityArr });
            })
            .catch(err => console.error('Error fetching cities:', err));
    }
    
    getStates() {
        return fetch(C.getUrl() + '/stateMaster/getallStates')
            .then(res => res.json())
            .then(data => {
                const stateArr = JSON.parse(data.message);
                this.setState({ stateArr });
            })
            .catch(err => console.error('Error fetching states:', err));
    }
    
    resetRegistrationForm() {
        this.setState({ registrationDate: null, firstName: '', middleName: '', lastName: '', emailId: '', dob: '',ageYears: '', ageMonths: '', ageDays: '', genderMstDto: { genderId: '' },
                        countryDto: { countryId: null, countryCode: '' }, phoneNumber1: '', doctor: { userId: '', firstName: '', lastName: '', username: '', roleName: '' },
                        instituteDto: { instituteId: null, instituteName: '' }, height: null, heightUnit: { unitId: null, unitName: '' }, weight: null, 
                        weightUnit: { unitId: null, unitName: '' }, patientComorbidities: [], patientAllergies: [], anyOngoingTreatment: null, 
                        patientComorbMed: [], patientRegErrors: [] ,addressLine1: '',addressLine2: '', pinCode: this.state.pinCode, countryName:''});
    }
    getPatientDoc() {
        if (localStorage.getItem("userRoleDto") !== null && localStorage.getItem("userRoleDto") !== ''
            && localStorage.getItem("userId") !== null && localStorage.getItem("userId") !== '') {
            let userRoleDto = JSON.parse(localStorage.getItem("userRoleDto"));
            let roleName = userRoleDto.roleName;
            if (roleName === 'Doctor') {
                let patientDoctor = {
                    userId: JSON.parse(localStorage.getItem("userId")),
                    firstName: localStorage.getItem("firstName"),
                    lastName: localStorage.getItem("lastName"),
                    roleName: roleName
                }
                this.setState({ doctor: patientDoctor });
            } else if (localStorage.getItem("associatedDocDto") !== null && localStorage.getItem("associatedDocDto") !== '') {
                let associateDocDto = JSON.parse(localStorage.getItem("associatedDocDto"));
                let patientDoctor = {
                    userId: JSON.parse(associateDocDto.userId),
                    firstName: associateDocDto.firstName,
                    lastName: associateDocDto.lastName,
                    roleName: roleName
                }
                this.setState({ doctor: patientDoctor });
            }
        }
    }

    savePatientDetial(event) {
        let isThisValidForm = false;
        if (this.validateGeneralInfo() && this.validateProfessionalInfo() && this.validateNewLocationFields()) {
            isThisValidForm = true;
        }
        var patientComorData = [];
        if (this.state.patientComorbidities !== null && this.state.patientComorbidities.size !== 0) {
            this.state.patientComorbidities.forEach(function (obj) {
                let datas = {
                    comorbiditiesDto: {
                        comorbiditiesId: obj.id, comorbiditiesName: obj.name
                    }
                }
                patientComorData.push(datas);
            });
        }
        var patientAllergiesData = [];
        if (this.state.patientAllergies !== null && this.state.patientAllergies.size !== 0) {
            this.state.patientAllergies.forEach(function (obj) {
                let data = {
                    allergiesMstDTO: {
                        allergiesId: obj.id, allergiesName: obj.name
                    }
                }
                patientAllergiesData.push(data);
            });
        }
        var patientComorMedData = [];
        if (this.state.patientComorbMed !== null && this.state.patientComorbMed.size !== 0) {
            this.state.patientComorbMed.forEach(function (obj) {
                let data = {
                    medicineMasterDto: {
                        medicineId: obj.id, medicineName: obj.name
                    }
                }
                patientComorMedData.push(data);
            });
        }
        var patientRegistrationObj = {
            registrationDate: this.state.registrationDate,
            firstName: this.state.firstName,
            middleName: this.state.middleName,
            lastName: this.state.lastName,
            emailId: this.state.emailId,
            addressLine1: this.state.addressLine1,
            addressLine2: this.state.addressLine2,
            pinCode: this.state.pinCode,          
            cityCode: this.state.selectedNewCity.cityCode,
            stateName: this.state.selectedNewState.stateName,
            countryName: this.state.selectedNewCountry.countryName,
            category: this.state.category,
            company: this.state.company,
            tarrif: this.state.tarrif,
            payType: this.state.payType,
            status: this.state.status,
            dob: this.state.dob,
            genderMstDto: {
                genderId: this.state.genderMstDto.genderId,
            },
            countryDto: {
                countryId: this.state.countryDto.countryId,
                countryCode: this.state.countryDto.countryCode,
                //countryName: this.state.countryDto.countryName, //newly added
            },
            phoneNumber1: this.state.phoneNumber1,
            doctor: {
                userId: this.state.doctor.userId,
                firstName: this.state.doctor.firstName,
                lastName: this.state.doctor.lastName,
                username: '',
                userRoleDto: {
                    roleName: this.state.doctor.roleName
                }
            },
            instituteDto: {
                instituteId: this.state.instituteDto.instituteId,
                instituteName: this.state.instituteDto.instituteName
            },
            // height: parseFloat(this.state.height),
            // heightUnitDto: { unitId: this.state.heightUnit.unitId, unitName: this.state.heightUnit.unitName },
            // weight: parseFloat(this.state.weight),
            // weightUnitDto: { unitId: this.state.weightUnit.unitId, unitName: this.state.weightUnit.unitName },
           // For height, set default height value and unit ID 1 if not provided
      height: this.state.height ? parseFloat(this.state.height) : 1,
      heightUnitDto: { 
        unitId: this.state.heightUnit ? this.state.heightUnit.unitId : 1, 
        unitName: this.state.heightUnit ? this.state.heightUnit.unitName : 'cm' 
      },
      
      // For weight, set default weight value and unit ID 1 if not provided
      weight: this.state.weight ? parseFloat(this.state.weight) : 1,
      weightUnitDto: { 
        unitId: this.state.weightUnit ? this.state.weightUnit.unitId : 1, 
        unitName: this.state.weightUnit ? this.state.weightUnit.unitName : 'KG' 
      },
            patientComorbidities: patientComorData,
            patientAllergies: patientAllergiesData,
            onGoingTreatment: this.state.anyOngoingTreatment,
            otherOngoingTreatment: this.state.isOngoingTreatmentSelected ? this.state.otherOngoingTreatment : '',
            patientComorbiditiesMedicines: patientComorMedData,
            allergies: this.state.allergies,
            otherComorbidities: this.state.otherComorbidities,
            profilePictureName: this.state.profilePictureName1,
            profilePictureData: this.state.profilePictureData1,

            // New fields for the payload
            maritalStatus: this.state.maritalStatus,
        bloodGroup: this.state.bloodGroup,
        religion: this.state.religion,
        education: this.state.education,
        occupation: this.state.occupation,
        id_proof_type: this.state.idProofType,
        id_proof_number: this.state.idProofNumber,
        emergency_contact_person: this.state.emergencyContactPerson,
        emergency_mobile_number: this.state.emergencyMobileNumber ? parseInt(this.state.emergencyMobileNumber, 10) : null,
        emergency_landline_number: this.state.emergencyLandlineNumber ? parseInt(this.state.emergencyLandlineNumber, 10) : null,
        emergency_mobile_type: this.state.emergencyMobileType,
        emergency_landline_type: this.state.emergencyLandlineType,
        emergency_contact_relation: this.state.emergencyContactRelation,
        primary_consultant: this.state.primaryConsultant,
        patient_type: this.state.patientType,
        telphoneNo: this.state.telephoneNumber,
        
        // Current address fields
        stateAddress1: this.state.currentAddressline1,
        stateAddress2: this.state.currentAddressLine2,
        statePincode: this.state.currentPinCode,
        stateCity: this.state.selectedCurrentCity.cityCode,
        stateCountry: this.state.selectedCurrentCountry.countryName,
        currentContryID: this.state.selectedCurrentCountry.countryId,
        stateCurrent: this.state.selectedCurrentState.stateName,

   // Referral information 
   referralSource: this.state.referralSource,
   referralHospital: this.state.referringHospital || "",
   referral_Detail: this.state.referralDetails || "",  // Match exact DTO property
   referring_Physician: this.state.referringPhysician || "",  // Exact match for DTO
   referring_Phy_Num: this.state.referringPhysicianNumber || ""  // Exact match for DTOperty


        }
        //console.log('--- REGITER PATIENT FORM : ' + JSON.stringify(patientRegistrationObj));
        if (isThisValidForm) {
            return fetch(C.getUrl() + '/userCase/registerPatient', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(patientRegistrationObj),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!",  text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({show: false});
                    swal({ title: "Patient Case created successfully!", icon: "success", buttons: false, timer: 2000, });
                    //this.setState({ saveLoader: false, successAlertshow: false })
                    window.location.reload(false);
                }
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
        }
    }

    parseCSVLine = (line) => {
        const result = [];
        let current = '';
        let inQuotes = false;
        for (let i = 0; i < line.length; i++) {
            const char = line[i];
            if (char === '"') {
                inQuotes = !inQuotes;
            } else if (char === ',' && !inQuotes) {
                result.push(current.trim());
                current = '';
            } else {
                current += char;
            }
        }
        result.push(current.trim());
        return result;
    }

    validateBulkUploadCSV = (csvText) => {
        const lines = csvText.split(/\r?\n/).filter(l => l.trim() !== '');
        if (lines.length < 2) {
            return [{ row: '-', errors: ['CSV file is empty or has no data rows.'] }];
        }

        const allCountries = Country.getAllCountries();
        const countryArr = this.state.countryArr;

        const RELATION_VALUES = ['Father', 'Mother', 'Spouse', 'Son', 'Daughter', 'Brother', 'Sister', 'Guardian', 'Friend'];

        const schema = [
            { name: 'First Name',                               mandatory: true,  type: 'text' },
            { name: 'Middle Name',                              mandatory: false, type: 'text' },
            { name: 'Last Name',                                mandatory: true,  type: 'text' },
            { name: 'email',                                    mandatory: false, type: 'email' },
            { name: 'Date of Birth',                            mandatory: true,  type: 'date' },
            { name: 'Gender',                                   mandatory: true,  type: 'dropdown', values: ['Male', 'Female', 'Other'] },
            { name: 'Blood Group',                              mandatory: true,  type: 'dropdown', values: ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-', 'Not known'] },
            { name: 'Religion',                                 mandatory: false, type: 'dropdown', values: ['Hinduism', 'Islam', 'Christianity', 'Sikhism', 'Buddhism', 'Jainism', 'Other'] },
            { name: 'Education',                                mandatory: false, type: 'dropdown', values: ['No Formal Education', 'Primary', 'Secondary', 'Higher Secondary', 'Graduate', 'Post Graduate', 'Doctorate'] },
            { name: 'Occupation',                               mandatory: false, type: 'dropdown', values: ['Unskilled Labour', 'Skilled Labour', 'Services', 'Self Employee', 'Businessman', 'Professional'] },
            { name: 'Marital Status',                           mandatory: false, type: 'dropdown', values: ['Single', 'Married', 'Divorced', 'Widowed'] },
            { name: 'ID Proof Type',                            mandatory: false, type: 'dropdown', values: ['Aadhaar Card', 'PAN Card', 'Passport', 'Driving License', 'Voter ID'] },
            { name: 'ID Proof Number',                          mandatory: false, type: 'text' },
            { name: 'Emergency Contact Person Name',            mandatory: true,  type: 'text' },
            { name: 'Emergency Contact Person Relation',        mandatory: true,  type: 'dropdown', values: RELATION_VALUES },
            { name: 'EC Country Code (eg IND)',                 mandatory: true,  type: 'area_code' },
            { name: 'Emergency Contact Mobile Number',          mandatory: true,  type: 'number' },
            { name: 'EC LL Country Code (eg IND)',              mandatory: false, type: 'area_code' },
            { name: 'Emergency Contact Landline Number',        mandatory: false, type: 'text' },
            { name: 'Contact Details Country Code (eg IND)',    mandatory: true,  type: 'area_code' },
            { name: 'Contact Details',                          mandatory: true,  type: 'number' },
            { name: 'Patient Landline Number',                  mandatory: false, type: 'text' },
            { name: 'Address Line 1',                           mandatory: true,  type: 'text' },
            { name: 'Address Line 2',                           mandatory: false, type: 'text' },
            { name: 'Country (eg India)',                       mandatory: true,  type: 'country' },
            { name: 'State (eg Maharashtra)',                   mandatory: true,  type: 'state',   dependsOnCountry: 'Country (eg India)' },
            { name: 'City (eg Mumbai)',                         mandatory: true,  type: 'city',    dependsOnCountry: 'Country (eg India)',       dependsOnState: 'State (eg Maharashtra)' },
            { name: 'Pincode (6 digit)',                        mandatory: true,  type: 'number' },
            { name: 'Current Address Line 1',                   mandatory: true,  type: 'text' },
            { name: 'Current Address Line 2',                   mandatory: false, type: 'text' },
            { name: 'Current Country (eg India)',               mandatory: true,  type: 'country' },
            { name: 'Current State (eg Maharashtra)',           mandatory: true,  type: 'state',   dependsOnCountry: 'Current Country (eg India)' },
            { name: 'Current City (eg Mumbai)',                 mandatory: true,  type: 'city',    dependsOnCountry: 'Current Country (eg India)', dependsOnState: 'Current State (eg Maharashtra)' },
            { name: 'Current Pincode (6 digit)',                mandatory: true,  type: 'number' },
            { name: 'Primary Consultant',                       mandatory: true,  type: 'text' },
            { name: 'Patient Type',                             mandatory: true,  type: 'dropdown', values: ['Inpatient', 'Outpatient', 'Emergency'] },
            { name: 'Referral Source',                          mandatory: false, type: 'dropdown', values: ['Self', 'Google', 'Social Media', 'Word of Mouth', 'Physician/Doctor', 'Hospital'] },
            { name: 'Referral Details',                         mandatory: false, type: 'text' },
            { name: 'Any Ongoing Treatments?',                  mandatory: false, type: 'dropdown', values: ['Yes', 'No', 'Not applicable', 'Prescribed but not taking'] },
            { name: 'Ongoing Treatment Details',                mandatory: false, type: 'text',     conditionalMandatory: { name: 'Any Ongoing Treatments?', value: 'Yes' } },
            { name: 'Comorbidities (semicolon separated)',      mandatory: false, type: 'text' },
            { name: 'Allergies (semicolon separated)',          mandatory: false, type: 'text' },
            { name: 'Is Registered Already?',                   mandatory: true,  type: 'dropdown', values: ['Yes', 'No', 'Not sure'] },
        ];

        // Build header → column index map from first row
        const headerRow = this.parseCSVLine(lines[0]);
        const headerIndex = {};
        headerRow.forEach((h, i) => { headerIndex[h.trim()] = i; });

        // Upfront check: report any missing mandatory columns before touching data rows
        const missingCols = schema
            .filter(f => f.mandatory && headerIndex[f.name] === undefined)
            .map(f => f.name);
        if (missingCols.length > 0) {
            return [{ row: 'Header', errors: [`Missing mandatory column(s): ${missingCols.join(', ')}`] }];
        }

        const allErrors = [];

        lines.slice(1).forEach((line, idx) => {
            const row = this.parseCSVLine(line);
            if (row.every(cell => !cell.trim())) return; // skip empty rows (e.g. template rows with no data)
            const rowNum = idx + 2;
            const rowErrors = [];

            schema.forEach(field => {
                const colIdx = headerIndex[field.name];
                if (colIdx === undefined) return; // optional column absent from file — skip

                const value = (row[colIdx] || '').trim();

                // Determine if mandatory (including conditional)
                let isMandatory = field.mandatory;
                if (field.conditionalMandatory) {
                    const depIdx = headerIndex[field.conditionalMandatory.name];
                    if (depIdx !== undefined) {
                        const depVal = (row[depIdx] || '').trim();
                        if (depVal.toLowerCase() === field.conditionalMandatory.value.toLowerCase()) {
                            isMandatory = true;
                        }
                    }
                }

                if (isMandatory && !value) {
                    rowErrors.push(`"${field.name}" is mandatory`);
                    return;
                }

                if (!value) return; // optional and empty — skip further checks

                switch (field.type) {
                    case 'email':
                        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                            rowErrors.push(`"${field.name}": invalid email format`);
                        }
                        break;
                    case 'date':
                        if (isNaN(Date.parse(value))) {
                            rowErrors.push(`"${field.name}": invalid date — use a recognisable format e.g. YYYY-MM-DD`);
                        }
                        break;
                    case 'number':
                        if (!/^\d+$/.test(value)) {
                            rowErrors.push(`"${field.name}": must contain digits only`);
                        }
                        break;
                    case 'dropdown': {
                        const allowed = field.values.map(v => v.toLowerCase());
                        if (!allowed.includes(value.toLowerCase())) {
                            rowErrors.push(`"${field.name}": invalid value "${value}". Allowed: ${field.values.join(', ')}`);
                        }
                        break;
                    }
                    case 'area_code': {
                        const val = value.toLowerCase();
                        const match = countryArr.some(c => {
                            const fullName  = c.name.toLowerCase();
                            const phoneCode = c.name.split(' ').slice(1).join(' ').toLowerCase();
                            return fullName === val || phoneCode === val;
                        });
                        if (!match) {
                            rowErrors.push(`"${field.name}": invalid area code "${value}". Use format "+91" or "IND +91"`);
                        }
                        break;
                    }
                    case 'country': {
                        if (!allCountries.find(c => c.name.toLowerCase() === value.toLowerCase())) {
                            rowErrors.push(`"${field.name}": invalid country "${value}"`);
                        }
                        break;
                    }
                    case 'state': {
                        const countryVal = (row[headerIndex[field.dependsOnCountry]] || '').trim();
                        const parentCountry = allCountries.find(c => c.name.toLowerCase() === countryVal.toLowerCase());
                        if (parentCountry) {
                            const states = State.getStatesOfCountry(parentCountry.isoCode);
                            if (!states.some(s => s.name.toLowerCase() === value.toLowerCase())) {
                                rowErrors.push(`"${field.name}": invalid state "${value}" for country "${countryVal}"`);
                            }
                        }
                        break;
                    }
                    case 'city': {
                        const countryVal = (row[headerIndex[field.dependsOnCountry]] || '').trim();
                        const stateVal   = (row[headerIndex[field.dependsOnState]]   || '').trim();
                        const parentCountry = allCountries.find(c => c.name.toLowerCase() === countryVal.toLowerCase());
                        if (parentCountry) {
                            const states = State.getStatesOfCountry(parentCountry.isoCode);
                            const parentState = states.find(s => s.name.toLowerCase() === stateVal.toLowerCase());
                            if (parentState) {
                                const cities = City.getCitiesOfState(parentCountry.isoCode, parentState.isoCode);
                                if (!cities.some(c => c.name.toLowerCase() === value.toLowerCase())) {
                                    rowErrors.push(`"${field.name}": invalid city "${value}" for state "${stateVal}"`);
                                }
                            }
                        }
                        break;
                    }
                    default:
                        break;
                }
            });

            if (rowErrors.length > 0) {
                allErrors.push({ row: rowNum, errors: rowErrors });
            }
        });

        return allErrors;
    }

    handleDownloadBulkTemplate = () => {
        const link = document.createElement('a');
        link.href = '/templates/patient-upload-template.xlsx';
        link.download = 'patient-upload-template.xlsx';
        link.click();
    }

    handleBulkUploadFileChange = (event) => {
        const file = event.target.files[0];
        this.setState({ bulkUploadFile: file, bulkUploadResult: null, bulkUploadError: null });
    }

    handleBulkUploadSubmit = () => {
        const { bulkUploadFile } = this.state;

        if (!bulkUploadFile) {
            this.setState({ bulkUploadError: 'Please select a file to upload.' });
            return;
        }

        const fileName = bulkUploadFile.name.toLowerCase();
        const isExcel = fileName.endsWith('.xls') || fileName.endsWith('.xlsx');

        const processCSV = (csvText) => {
            const validationErrors = this.validateBulkUploadCSV(csvText);
            if (validationErrors.length > 0) {
                this.setState({ bulkValidationErrors: validationErrors, bulkUploadResult: null, bulkUploadError: null });
                return;
            }

            // Validation passed — strip empty rows then send as CSV to backend
            const instituteArr = this.state.instituteArr;
            if (!instituteArr || instituteArr.length === 0) {
                this.setState({ bulkUploadError: 'Unable to determine your associated institute. Please close and reopen the dialog.' });
                return;
            }
            const csvLines = csvText.split(/\r?\n/);
            const filteredCSV = [
                csvLines[0], // always keep header row
                ...csvLines.slice(1).filter(line => !this.parseCSVLine(line).every(cell => !cell.trim()))
            ].join('\n');
            const csvBlob = new Blob([filteredCSV], { type: 'text/csv' });
            const csvFileName = bulkUploadFile.name.replace(/\.(xlsx?)/i, '.csv');
            const formData = new FormData();
            formData.append('file', csvBlob, csvFileName);
            formData.append('instituteId', instituteArr[0].id);
            formData.append('instituteName', instituteArr[0].name);
            const doctorId = localStorage.getItem('userId');
            const bulkUploadUrl = C.getUrl() + '/userCase/bulkRegisterPatients?doctorId=' + doctorId;

            this.setState({ bulkUploadLoading: true, bulkUploadResult: null, bulkUploadError: null, bulkValidationErrors: null });
            fetch(bulkUploadUrl, {
                method: 'POST',
                mode: 'cors',
                body: formData,
            })
            .then(res => res.json())
            .then(res => {
                const result = res.data || res;
                this.setState({ bulkUploadLoading: false, bulkUploadResult: result });
                if (result.failureCount === 0) {
                    this.closeBulkUploadModal();
                    swal({ title: 'Patients uploaded successfully!', text: `${result.successCount} patient(s) registered.`, icon: 'success', buttons: false, timer: 3000 });
                }
            })
            .catch(err => {
                console.error('[BulkUpload] error:', err);
                this.setState({ bulkUploadLoading: false, bulkUploadError: 'Upload failed: ' + err });
            });
        };

        const reader = new FileReader();

        if (isExcel) {
            reader.onload = (e) => {
                try {
                    const workbook = XLSX.read(e.target.result, { type: 'array' });
                    const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
                    processCSV(XLSX.utils.sheet_to_csv(firstSheet));
                } catch (err) {
                    console.error('[BulkUpload] Excel read error:', err);
                    this.setState({ bulkUploadError: 'Failed to read Excel file: ' + err });
                }
            };
            reader.readAsArrayBuffer(bulkUploadFile);
        } else {
            reader.onload = (e) => processCSV(e.target.result);
            reader.readAsText(bulkUploadFile);
        }
    }

    closeBulkUploadModal = () => {
        this.setState({ showBulkUpload: false, bulkUploadFile: null, bulkUploadResult: null, bulkUploadError: null, bulkUploadLoading: false, bulkValidationErrors: null });
    }

// Add this method to validate current address fields
validateCurrentLocationFields = () => {
    let isValid = true;
    const { patientRegErrors } = this.state;
    
    // Skip validation if using permanent address
    if (this.state.sameAsPermanent) {
        return true;
    }
    
    // Validate current country
    if (!this.state.selectedCurrentCountry.countryId) {
        patientRegErrors["currentCountry"] = "Please select a country";
        isValid = false;
    } else {
        patientRegErrors["currentCountry"] = "";
    }
    
    // Validate current state
    if (this.state.selectedCurrentCountry.countryId && !this.state.selectedCurrentState.stateId) {
        patientRegErrors["currentState"] = "Please select a state";
        isValid = false;
    } else {
        patientRegErrors["currentState"] = "";
    }
    
    // Validate current city
    if (this.state.selectedCurrentState.stateId && !this.state.selectedCurrentCity.cityId) {
        patientRegErrors["currentCity"] = "Please select a city";
        isValid = false;
    } else {
        patientRegErrors["currentCity"] = "";
    }
    
    // Update state with errors
    this.setState({ patientRegErrors });
    return isValid;
}
    // Comprehensive validation method for age inputs
validateAgeInput = (value, field) => {
    // If empty value, return as is
    if (value === '') return value;
    
    // Convert to number for comparison
    let numValue = parseInt(value, 10);
    
    switch (field) {
        case 'ageYears':
            // Limit to 2 digits and max value of 99
            if (value.length > 2) {
                return value.slice(0, 2);
            }
            return numValue > 99 ? '99' : value;
            
        case 'ageMonths':
            // Ensure months are between 1 and 12
            if (numValue > 12) {
                return '12';
            }
            return numValue < 1 ? '1' : value;
            
        case 'ageDays':
            // Get the current month and year from state
            const { ageYears, ageMonths } = this.state;
            let maxDays = 31;
            
            // Calculate max days for the specific month
            if (ageMonths !== '') {
                const currentDate = moment();
                // Subtract one from ageMonths when calculating because moment uses 0-based months
                const targetMonth = currentDate
                    .subtract(ageYears || 0, 'years')
                    .subtract((ageMonths - 1) || 0, 'months');
                maxDays = targetMonth.daysInMonth();
            }
            
            if (numValue > maxDays) {
                return maxDays.toString();
            }
            return numValue < 1 ? '1' : value;
            
        default:
            return value;
    }
};

    // DOB value adapter for the shared PatientRegistrationForm DatePicker.
    // Case stores dob as a normalized YYYY-MM-DD string, so convert to a moment.
    getDobPickerValue = (d) => this.parseDobForDatePicker(d);

    // Commit a country/state/city pick coming from guided voice mode, reusing
    // the exact same handlers + search-term state as the manual dropdown onClick.
    handleVoiceCombo = (kind, item) => {
        const id = item ? item.id : "";
        const name = item ? item.name : "";
        if (kind === 'country') {
            this.handleNewCountryChange({ target: { value: id } });
            this.setState({ countrySearchTerm: name, isCountryDropdownOpen: false });
        } else if (kind === 'state') {
            this.handleNewStateChange({ target: { value: id } });
            this.setState({ stateSearchTerm: name, isStateDropdownOpen: false });
        } else if (kind === 'city') {
            this.handleNewCityChange({ target: { value: id } });
            this.setState({ citySearchTerm: name, isCityDropdownOpen: false });
        }
    };

    // Modify your existing setDOB method to use clearAgeFields
    setDOB = (date) => {
        // Normalize the date to YYYY-MM-DD string format for consistent storage and transmission
        let normalizedDate = date;
        if (date) {
            if (moment.isMoment(date)) {
                normalizedDate = date.format('YYYY-MM-DD');
            } else if (typeof date === 'string') {
                const parsed = moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD', 'MMM DD, YYYY'], true);
                if (parsed.isValid()) {
                    normalizedDate = parsed.format('YYYY-MM-DD');
                }
            } else {
                // Try to parse as Date object
                const parsed = moment(date);
                if (parsed.isValid()) {
                    normalizedDate = parsed.format('YYYY-MM-DD');
                }
            }
        }
        
        this.setState({ dob: normalizedDate }, () => {
            if (normalizedDate) {
                const today = moment();
                const birthDate = moment(normalizedDate, 'YYYY-MM-DD');
                const duration = moment.duration(today.diff(birthDate));
                
                this.setState({
                    ageYears: Math.floor(duration.asYears()),
                    ageMonths: Math.floor(duration.asMonths() % 12),
                    ageDays: Math.floor(duration.asDays() % 30)
                });

                if (this.props.onDOBChange) {
                    this.props.onDOBChange(normalizedDate);
                }
            } else {
                this.clearAgeFields();
            }
        });
    };

    clearAgeFields = () => {
        this.setState({
            ageYears: '',
            ageMonths: '',
            ageDays: '',
            dob: null
        }, () => {
            // Notify parent about DOB being cleared
            if (this.props.onDOBChange) {
                this.props.onDOBChange(null);
            }
        });
    };

    // Helper function to safely parse DOB for DatePicker display
    parseDobForDatePicker(dob) {
        if (!dob) return null;
        const m = moment(dob, ['DD/MM/YYYY', 'YYYY-MM-DD', 'MMM DD, YYYY']);
        return m.isValid() ? m : null;
    }

    // Modified handleAgeChange to handle 1-based months
handleAgeChange = (field, value) => {
    // First validate the input
    const validatedValue = this.validateAgeInput(value, field);
    const numValue = validatedValue === '' ? '' : parseInt(validatedValue, 10);
    
    this.setState({ [field]: numValue }, () => {
        const { ageYears, ageMonths, ageDays } = this.state;
        
        // If years field is cleared, clear everything
        if (field === 'ageYears' && validatedValue === '') {
            this.clearAgeFields();
            return;
        }

        // Only calculate DOB if we have at least years
        if (ageYears !== '') {
            const today = moment();
            const calculatedDate = today
                .subtract(ageYears || 0, 'years')
                // Subtract one from months when calculating because moment uses 0-based months
                .subtract(((ageMonths || 1) - 1), 'months')
                .subtract((ageDays || 1) - 1, 'days')
                .startOf('day');
            
            // Validate the calculated date
            if (calculatedDate.isValid()) {
                this.setState({ dob: calculatedDate }, () => {
                    if (this.props.onDOBChange) {
                        this.props.onDOBChange(calculatedDate);
                    }
                });
            }
        }
    });
};
    

    setSelectedDocData = (data) => {
        if (localStorage.getItem("userRoleDto") !== null && localStorage.getItem("userRoleDto") !== ''
            && localStorage.getItem("userId") !== null && localStorage.getItem("userId") !== '') {
            let userRoleDto = JSON.parse(localStorage.getItem("userRoleDto"));
            let name = userRoleDto.roleName;
            this.setState({
                doctor: {
                    userId: data.id,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    roleName: name
                },
                isAssociatedDocSelected: true,
            });
            this.getAllInstituteAssociated(data.id);
        }
    }

    profilePicHandler(e) {
        console.log('--> PROFILE PIC :: ' + e.target.files[0].name);
        console.log('--> PROFILE PIC [file type] :: ' + e.target.files[0].type);
        let file = e.target.files[0];
        let fileType = e.target.files[0].type;
        let validFileType = this.isValidFileType(fileType);
        
        if (file && validFileType) {
            const reader = new FileReader();
            reader.onload = this.fileReaderHandler;
            reader.readAsBinaryString(file);
            this.setState({
                profilePictureName1: e.target.files[0].name
            });
        }
    }

    fileReaderHandler(readerEvent) {
        let binaryString = readerEvent.target.result;
        let imageData = 'data:image/jpeg;base64,' + btoa(binaryString);
        console.log('--> BASE64 DATA : ' + imageData);
        this.setState({
            profilePictureData1: imageData
        });
    }

    isValidFileType(type) {
        switch (type) {
            case 'image/png':
            case 'image/jpeg':
            case 'image/jpg':
                return true;
            default:
                return false;
        }
    }

// Updated handler for "Same as Permanent Address" checkbox
// // Enhanced "Same as Permanent Address" handler
// handleSameAddressChange = (event) => {
//     const isChecked = event.target.checked;
    
//     if (isChecked) {
//         this.setState({
//             sameAsPermanent: true,
//             currentAddressLine1: this.state.addressLine1 || '',
//             currentAddressLine2: this.state.addressLine2 || '',
//             currentPinCode: this.state.pinCode || '',
//             selectedCurrentCountry: {...this.state.selectedNewCountry},
//             selectedCurrentState: {...this.state.selectedNewState},
//             selectedCurrentCity: {...this.state.selectedNewCity},
//             currentCountryList: this.state.newCountryList,
//             currentStateList: this.state.newStateList,
//             currentCityList: this.state.newCityList,
//             isCurrentStateDropdownDisabled: this.state.isNewStateDropdownDisabled,
//             isCurrentCityDropdownDisabled: this.state.isNewCityDropdownDisabled
//         });
//     } else {
//         this.setState({
//             sameAsPermanent: false,
//             currentAddressLine1: '',
//             currentAddressLine2: '',
//             currentPinCode: '',
//             selectedCurrentCountry: { countryId: null, countryName: '' },
//             selectedCurrentState: { stateId: null, stateName: '' },
//             selectedCurrentCity: { cityId: null, cityCode: '' },
//             isCurrentStateDropdownDisabled: true,
//             isCurrentCityDropdownDisabled: true
//         });
//     }
// };

// Add method to handle "Same as Permanent Address" checkbox
handleSameAddressChange(e) {
    const checked = e.target.checked;
    
    if (checked) {
        this.setState({
            sameAsPermanent: true,
            selectedCurrentCountry: this.state.selectedNewCountry,
            selectedCurrentState: this.state.selectedNewState,
            selectedCurrentCity: this.state.selectedNewCity,
            currentCountrySearchTerm: this.state.countrySearchTerm,
            currentStateSearchTerm: this.state.stateSearchTerm,
            currentCitySearchTerm: this.state.citySearchTerm
        });
        
        // Also update the filtered lists for current address
        this.setState({
            filteredCurrentCountryList: this.state.filteredCountryList,
            filteredCurrentStateList: this.state.filteredStateList,
            filteredCurrentCityList: this.state.filteredCityList
        });
    } else {
        this.setState({
            sameAsPermanent: false
        });
    }
}
// Update handleReferralSourceChange to correctly handle referralDetails
handleReferralSourceChange = (event) => {
    const selectedValue = event.target.value;
    
    if (selectedValue !== "DEFAULT") {
        this.setState({
            referralSource: selectedValue,
            selectedReferralSource: selectedValue,
            
            // Clear fields based on selection
            referringPhysician: (selectedValue === 'Physician/Doctor' || selectedValue === 'Hospital') 
                ? this.state.referringPhysician 
                : '',
            referringPhysicianNumber: (selectedValue === 'Physician/Doctor' || selectedValue === 'Hospital') 
                ? this.state.referringPhysicianNumber 
                : '',
            referralDetails: (selectedValue !== 'Physician/Doctor' && selectedValue !== 'Hospital') 
                ? this.state.referralDetails 
                : ''
        });
    }
};

// Integrated location search method
handleLocationSearch = (type, field, searchTerm) => {
    let sourceList = [];
    let targetStateField = '';
    
    if (type === 'permanent') {
        switch(field) {
            case 'country':
                sourceList = this.state.newCountryList;
                targetStateField = 'filteredCountryList';
                break;
            case 'state': 
                sourceList = this.state.newStateList;
                targetStateField = 'filteredStateList';
                break;
            case 'city':
                sourceList = this.state.newCityList;
                targetStateField = 'filteredCityList';
                break;
        }
    } else if (type === 'current') {
        switch(field) {
            case 'country':
                sourceList = this.state.currentCountryList;
                targetStateField = 'filteredCurrentCountryList';
                break;
            case 'state': 
                sourceList = this.state.currentStateList;
                targetStateField = 'filteredCurrentStateList';
                break;
            case 'city':
                sourceList = this.state.currentCityList;
                targetStateField = 'filteredCurrentCityList';
                break;
        }
    }
    
    if (sourceList && sourceList.length > 0) {
        const normalizedSearchTerm = searchTerm.toLowerCase();
        const filteredList = sourceList.filter(item => 
            item.name.toLowerCase().includes(normalizedSearchTerm)
        );
        
        const stateUpdate = {};
        stateUpdate[targetStateField] = filteredList;
        this.setState(stateUpdate);
    }
};
    render() {
        const { isHospitalStaff, isAssociatedDocSelected, associatedDocList,dob, ageYears, ageMonths, ageDays} = this.state;
        let header;
        if (isHospitalStaff) {
            header = [{title: '#', prop: 'id', sortable: true, filterable: true},{title: 'Name', prop: 'name', sortable: true, filterable: true},{title: 'Case ID', prop: 'caseId', sortable: true, filterable: true},{title: 'Gender', prop: 'gender', sortable: true, filterable: true},{title: 'Mobile No.', prop: 'mobileNo', sortable: true, filterable: true},{title: 'Hospital', prop: 'hospital', sortable: true, filterable: true},{title: 'Doctor Name', prop: 'doctorName', sortable: true, filterable: true},{title: 'Action', prop: 'button'},];
        }else {
            header = [{title: '#', prop: 'id', sortable: true, filterable: true},{title: 'Name', prop: 'name', sortable: true, filterable: true},{title: 'Case ID', prop: 'caseId', sortable: true, filterable: true},{title: 'Gender', prop: 'gender', sortable: true, filterable: true},{title: 'Mobile No.', prop: 'mobileNo', sortable: true, filterable: true},{title: 'Hospital', prop: 'hospital', sortable: true, filterable: true},{title: 'Action', prop: 'button'},];
        }
        let headerActive;
        if (isHospitalStaff) {
            headerActive = [{title: '#', prop: 'id', sortable: true, filterable: true},{title: 'Name', prop: 'name', sortable: true, filterable: true},{title: 'Case ID', prop: 'caseId', sortable: true, filterable: true},{title: 'Gender', prop: 'gender', sortable: true, filterable: true},{title: 'Mobile No.', prop: 'mobileNo', sortable: true, filterable: true},{title: 'Hospital', prop: 'hospital', sortable: true, filterable: true},{title: 'Doctor Name', prop: 'doctorName', sortable: true, filterable: true},{title: 'Action', prop: 'button'},];
        }else {
            headerActive = [{title: '#', prop: 'id', sortable: true, filterable: true},{title: 'Name', prop: 'name', sortable: true, filterable: true},{title: 'Case ID', prop: 'caseId', sortable: true, filterable: true},{title: 'Gender', prop: 'gender', sortable: true, filterable: true},{title: 'Mobile No.', prop: 'mobileNo', sortable: true, filterable: true},{title: 'Hospital', prop: 'hospital', sortable: true, filterable: true},{title: 'Action', prop: 'button'},];
        }
        const headerPending = [{title: '#', prop: 'id', sortable: true, filterable: true},{title: 'Name', prop: 'name', sortable: true, filterable: true},{title: 'Case ID', prop: 'caseId', sortable: true, filterable: true},{title: 'Gender', prop: 'gender', sortable: true, filterable: true},{title: 'Mobile No.', prop: 'mobileNo', sortable: true, filterable: true},{title: 'Hospital', prop: 'hospital', sortable: true, filterable: true},];
        const customLabels = {show: 'Display', entries: 'rows', noResults: 'No records found'};
        const classes = {table: 'table-striped table-striped table-hover text-nowrap dataTable mt-4', thead: 'thead-light'};
        
        return (
            <div className="d-flex" id="wrapper">
                {<Side />}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        {<Top />}
                        <div className="container-fluid">
                            <div className="app-content">
                                <section className="section" id="accordion">
                                    <Row>
                                        <Col lg='12' className="mt-4 mb-4">
                                            <Button variant="secondary" className="float-right" onClick={this.showPatientDialog.bind(this)}><FaPlus className='mr-2 mb-1'/>New Patient</Button>
                                            {this.features.bulkPatientUpload && <Button variant="outline-secondary" className="float-right mr-2" onClick={() => { this.getallCountries(); this.getAllInstitute(); this.setState({ showBulkUpload: true }); }}><FaPlus className='mr-2 mb-1'/>Multiple Patients Upload</Button>}
                                        </Col>
                                        <Col lg='12'>
                                            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                                <Row>
                                                    <Col lg='2'>
                                                        <div className="card">
                                                            <div className="card-header"><h3 className="font-weight-bold mb-0 text-black">My Cases</h3></div>
                                                            <div className="card-body p-0" id="mycard-collapse">
                                                                <Nav variant="pills" className="flex-column list-group list-cyan">
                                                                    <Nav.Item>
                                                                        <Nav.Link className="list-group-item list-group-item-action radius-0" eventKey="first" onClick={() => this.getActiveCases()}>
                                                                            <span><FaList className='mr-4' style={{ verticalAlign: "text-top" }} /></span>Active Cases
                                                                        </Nav.Link>
                                                                    </Nav.Item>
                                                                    {(() => {
                                                                        if (!isHospitalStaff) {
                                                                            return (
                                                                                <Nav.Item>
                                                                                    <Nav.Link className="list-group-item list-group-item-action radius-0" eventKey="second" onClick={() => this.getPendingCases()}>
                                                                                        <span><FaList className='mr-4' style={{ verticalAlign: "text-top" }} /></span>Pending Approval
                                                                                    </Nav.Link>
                                                                                </Nav.Item>
                                                                            )
                                                                        }
                                                                    })()}
                                                                    <Nav.Item>
                                                                        <Nav.Link className="list-group-item list-group-item-action radius-0" eventKey="fourth" onClick={() => this.getArchivedCases()}>
                                                                            <span><FaList className='mr-4' style={{ verticalAlign: "text-top" }} /></span>Archived Cases
                                                                        </Nav.Link>
                                                                    </Nav.Item>
                                                                    <Nav.Item>
                                                                        <Nav.Link className="list-group-item list-group-item-action radius-0" eventKey="fifth" onClick={() => this.getAllCases()}>
                                                                            <span><FaList className='mr-4' style={{ verticalAlign: "text-top" }} /></span>All Cases
                                                                        </Nav.Link>
                                                                    </Nav.Item>
                                                                </Nav>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col lg='10'>
                                                        <Tab.Content>
                                                            <Tab.Pane eventKey="first">
                                                                <div id="collapseDraft" className="card border-0 pb-0 collapse show" data-parent="#accordion">
                                                                    <div className="card-header flex-wrap">
                                                                        <h3 className="fs-18 mb-0 text-black">Active Cases</h3>
                                                                    </div>
                                                                    <div className="card-body p-3">
                                                                        <Row className="mb-3">
                                                                            <Col lg='12'>
                                                                                <CustomTable
                                                                                    id="datatableActiveCases"
                                                                                    tableHeaders={headerActive}
                                                                                    tableBody={this.state.activeCaseData} 
                                                                                    rowsPerPage={5}
                                                                                    initialSort={{ prop: 'id', isAscending: true }}
                                                                                    labels={customLabels}
                                                                                    classes={classes}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </div>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey="second">
                                                                <div id="collapseDraft" className="card border-0 pb-0 collapse show" data-parent="#accordion">
                                                                    <div className="card-header flex-wrap">
                                                                        <h3 className="fs-18 mb-0 text-black">Pending Approval</h3>
                                                                    </div>
                                                                    <div className="card-body p-3">
                                                                        <Row className="mb-3">
                                                                            <Col lg='12'>
                                                                                <CustomTable
                                                                                    id="datatablePendingCases"
                                                                                    tableHeaders={headerPending}
                                                                                    tableBody={this.state.pendingCaseData} 
                                                                                    rowsPerPage={5}
                                                                                    initialSort={{ prop: 'id', isAscending: true }}
                                                                                    labels={customLabels}
                                                                                    classes={classes}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </div>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey="third">
                                                                <div id="collapseDraft" className="card border-0 pb-0 collapse show" data-parent="#accordion">
                                                                    <div className="card-header flex-wrap ">
                                                                        <h3 className="fs-18 mb-0 text-black">Transferred Cases</h3>
                                                                    </div>
                                                                    <div className="card-body p-3">
                                                                        <Row className="mb-3">
                                                                            <Col lg='6'>
                                                                                <div className="input-group">
                                                                                    <Form.Control type="text" id="transferSearchBar" placeholder="Search by Patient Name, Case No. or Contact No." />
                                                                                    <span className="input-group-addon"><FaSearch className='' /></span>
                                                                                </div>
                                                                            </Col>
                                                                            <Col lg='3'></Col>
                                                                            <Col lg='2'>
                                                                                <span className="pull-right Dj mr-3 pt-2"><span><span className="ts">1</span>–<span className="ts">5</span></span> of <span className="ts">10</span></span>
                                                                            </Col>
                                                                            <Col lg='1'>
                                                                                <div>
                                                                                    <ButtonGroup className="pull-right">
                                                                                        <Button><FaArrowAltCircleLeft size='2rem' /></Button>
                                                                                        <Button><FaArrowAltCircleRight size='2rem' /></Button>
                                                                                    </ButtonGroup>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col lg='12'>
                                                                                <table id="transferCases" className="table table-striped table-hover text-nowrap dataTable no-footer" role="grid" aria-describedby="example_info">
                                                                                    <thead className="thead-light">
                                                                                        <tr role="row">
                                                                                            <th aria-controls="example" colSpan="1">#</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Patient Name</th>
                                                                                            <th className="sorting" aria-controls="example" colSpan="1">Case ID</th>
                                                                                            <th className="sorting" aria-controls="example" colSpan="1">Gender</th>
                                                                                            <th className="sorting" aria-controls="example" colSpan="1">Contact No.</th>
                                                                                            <th className="sorting" aria-controls="example" colSpan="1">Hospital</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr role="row" className="odd">
                                                                                            <td><Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle w-32 mr-2" /></td>
                                                                                            <td className="sorting_1"><a className="nav-link" href="/CaseProfile">Mark Otto</a></td>
                                                                                            <td>#3654</td>
                                                                                            <td>Male</td>
                                                                                            <td>1234567890</td>
                                                                                            <td>Transferred</td>
                                                                                        </tr>
                                                                                        <tr role="row" className="odd">
                                                                                            <td><Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle w-32 mr-2" /></td>
                                                                                            <td className="sorting_1"><a className="nav-link" href="/CaseProfile">Mark Gardner</a></td>
                                                                                            <td>#3654</td>
                                                                                            <td>Male</td>
                                                                                            <td>1234567890</td>
                                                                                            <td>Transferred</td>
                                                                                        </tr>
                                                                                        <tr role="row" className="odd">
                                                                                            <td><Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle w-32 mr-2" /></td>
                                                                                            <td className="sorting_1"><a className="nav-link" href="/CaseProfile">Donald Gardner</a></td>
                                                                                            <td>#3654</td>
                                                                                            <td>Male</td>
                                                                                            <td>1234567890</td>
                                                                                            <td>Transferred</td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </div>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey="fourth">
                                                                <div id="collapseDraft" className="card border-0 pb-0 collapse show" data-parent="#accordion">
                                                                    <div className="card-header flex-wrap">
                                                                        <h3 className="fs-18 mb-0 text-black">Archived Cases</h3>
                                                                    </div>
                                                                    <div className="card-body p-3">
                                                                        <Row className="mb-3">
                                                                            <Col lg='12'>
                                                                                <CustomTable
                                                                                    id="datatableArchivedCases"
                                                                                    tableHeaders={header}
                                                                                    tableBody={this.state.archivedCaseData} 
                                                                                    rowsPerPage={5}
                                                                                    initialSort={{ prop: 'id', isAscending: true }}
                                                                                    labels={customLabels}
                                                                                    classes={classes}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </div>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey="fifth">
                                                                <div id="collapseDraft" className="card border-0 pb-0 collapse show" data-parent="#accordion">
                                                                    <div className="card-header flex-wrap">
                                                                        <h3 className="fs-18 mb-0 text-black">All Cases</h3>
                                                                    </div>
                                                                    <div className="card-body p-3">
                                                                        <Row className="mb-3">
                                                                            <Col lg='12'>
                                                                                <CustomTable
                                                                                    id="datatableAllCases"
                                                                                    tableHeaders={header}
                                                                                    tableBody={this.state.allCaseData} 
                                                                                    rowsPerPage={5}
                                                                                    initialSort={{ prop: 'id', isAscending: true }}
                                                                                    labels={customLabels}
                                                                                    classes={classes}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </div>
                                                            </Tab.Pane>
                                                        </Tab.Content>
                                                    </Col>
                                                </Row>
                                            </Tab.Container>
                                        </Col>
                                    </Row>

                                    <PatientRegistrationForm
                                        ctx={this}
                                        isHospitalStaff={isHospitalStaff}
                                        isAssociatedDocSelected={isAssociatedDocSelected}
                                        associatedDocList={associatedDocList}
                                        dob={dob}
                                        ageYears={ageYears}
                                        ageMonths={ageMonths}
                                        ageDays={ageDays}
                                    />

                                    {/* Bulk Upload Modal */}
                                    <Modal show={this.state.showBulkUpload} animation={true} centered size="lg" scrollable>
                                        <Modal.Header closeButton onClick={this.closeBulkUploadModal}>
                                            <Modal.Title>
                                                <h3 className="fs-18 header_title mb-0 text-black">Multiple Patients Upload</h3>
                                            </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Container className="p-2">
                                                <Row>
                                                    <Col lg='12' className="mb-3">
                                                        <Form.Group>
                                                            <Form.Label className="font-weight-bold">Select CSV File</Form.Label>
                                                            <Form.Control
                                                                type="file"
                                                                accept=".csv,.xls,.xlsx"
                                                                onChange={this.handleBulkUploadFileChange}
                                                            />
                                                            <Form.Text className="text-muted">Accepted formats: .csv, .xls, .xlsx</Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                {this.state.bulkUploadError && (
                                                    <Row>
                                                        <Col lg='12'>
                                                            <div className="alert alert-danger">{this.state.bulkUploadError}</div>
                                                        </Col>
                                                    </Row>
                                                )}

                                                {this.state.bulkValidationErrors && this.state.bulkValidationErrors.length > 0 && (
                                                    <Row>
                                                        <Col lg='12'>
                                                            <div className="alert alert-warning">
                                                                <strong>Validation failed. Please fix the following errors before uploading:</strong>
                                                            </div>
                                                            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                                <table className="table table-bordered table-sm">
                                                                    <thead className="thead-light">
                                                                        <tr>
                                                                            <th style={{ width: '80px' }}>Row</th>
                                                                            <th>Errors</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.bulkValidationErrors.map((e, idx) => (
                                                                            <tr key={idx} className="table-danger">
                                                                                <td>{e.row}</td>
                                                                                <td>
                                                                                    <ul className="mb-0 pl-3">
                                                                                        {e.errors.map((err, i) => <li key={i}>{err}</li>)}
                                                                                    </ul>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                )}

                                                {this.state.bulkUploadResult && (
                                                    <Row>
                                                        <Col lg='12'>
                                                            {this.state.bulkUploadResult.failureCount > 0 && (
                                                                <div className="alert alert-danger mb-2">
                                                                    <strong>Upload completed with errors.</strong> {this.state.bulkUploadResult.failureCount} record(s) failed. Please review the details below.
                                                                </div>
                                                            )}
                                                            <div className="alert alert-info mb-3">
                                                                <strong>Total Rows:</strong> {this.state.bulkUploadResult.totalRows} &nbsp;|&nbsp;
                                                                <strong className="text-success">Success:</strong> {this.state.bulkUploadResult.successCount} &nbsp;|&nbsp;
                                                                <strong className="text-danger">Failed:</strong> {this.state.bulkUploadResult.failureCount}
                                                            </div>
                                                            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                                <table className="table table-bordered table-sm">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Row</th>
                                                                            <th>Status</th>
                                                                            <th>Details</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.bulkUploadResult.results && this.state.bulkUploadResult.results.map((r, idx) => (
                                                                            <tr key={idx} className={r.status === 'SUCCESS' ? 'table-success' : r.status === 'SKIPPED' ? 'table-warning' : 'table-danger'}>
                                                                                <td>{r.row}</td>
                                                                                <td>{r.status}</td>
                                                                                <td>
                                                                                    {r.status === 'SUCCESS' ? (
                                                                                        <div>
                                                                                            <span>Case ID: {r.caseId || r.patientId || '-'}</span>
                                                                                            {r.warnings && r.warnings.length > 0 && (
                                                                                                <div className="alert alert-warning mt-1 mb-0 p-1" style={{ fontSize: '0.85em' }}>
                                                                                                    <strong>Warnings:</strong>
                                                                                                    <ul className="mb-0 pl-3 mt-1">
                                                                                                        {r.warnings.map((w, wi) => <li key={wi}>{w}</li>)}
                                                                                                    </ul>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    ) : (
                                                                                        r.message || '-'
                                                                                    )}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                )}

                                                <Row className="mt-3">
                                                    <Col lg='12'>
                                                        <Button
                                                            variant="secondary"
                                                            className="pull-right"
                                                            onClick={this.handleBulkUploadSubmit}
                                                            disabled={this.state.bulkUploadLoading}
                                                        >
                                                            {this.state.bulkUploadLoading && (
                                                                <Spinner className='mr-2' animation='border' size='sm' />
                                                            )}
                                                            Upload
                                                        </Button>
                                                        <Button variant="outline-primary" className="pull-right mr-2" onClick={this.handleDownloadBulkTemplate}>
                                                            Download Template
                                                        </Button>
                                                        <Button variant="light" className="pull-right mr-2" onClick={this.closeBulkUploadModal}>
                                                            Cancel
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </Modal.Body>
                                    </Modal>
                                    {/* End Bulk Upload Modal */}

                                </section>
                            </div>
                        </div>
                        <Loader show={this.state.loaderModal} />
                    </div>
                </div>
            </div>
        )
    }
}